import { provideErrTranslations, Jsx6, h, t, T, insert, setVisible, setValue, isVisible, fireCustom, Jsx6old, addClass, listen, replaceContent, setAttribute } from '@jsx6/jsx6'
import { areaChat } from './chat/areaChat.jsx'
import { areaEndInvite } from './chat/areaEndInvite.jsx'
import { areaError } from './chat/areaError.js'
import { areaThankYou } from './chat/areaThankYou.js'
import { areaDevicesError } from './chat/areaDevicesError.js'
import { areaForm } from './chat/areaForm.js'
import { areaQuestion } from './chat/areaQuestion.js'
import { areaSettings } from './chat/areaSettings.js'
import { areaSurvey } from './chat/areaSurvey.js'
import { expiredChat } from './chat/expiredChat.js'
import { incomingCallModal } from './chat/incomingCallModal.js'
import { chatSurvey } from './chat/chatSurvey.js'
import { makeKey } from './makeKey.js'
import {
  formData,
  b64DecodeUnicode,
  readCookie,
  attachSinkId,
  cleanupPhoneNumber,
  validatePhoneNumber,
  videoInDeviceChanged,
  audioInDeviceChanged, nl2br,
  parseIncomingMessage
} from 'chat-util'
import { classIf } from './classIf.js'
import { deviceOption } from './deviceOption.js'
import { fillSelect } from './chat/fillSelect.js'
import { ChatOptions } from './ChatOptions.js'
import { areaButton } from './chat/areaButton.js'
import { areaGeneralError } from './chat/areaGeneralError.js'
import { unavailableChat } from './chat/unavailableChat.js'
import { initializeEid } from './scanID/index.js'
// @typedef {import('./ChatOptions.js').ChatOptions} ChatOptions

const localUrl = path => new URL(path, import.meta.url)
const iosMobileReg = /(iPhone|iPod|iPad)/i;
window.streams = []
const trackStream = s=>{window.streams.push(s); return s}
provideErrTranslations()

let rpcSequnece = 0
let responseMap = new Map()
const INVITE = window.INVITE || {}

const FORM_DATA_KEY = 'nexios.chat.formData'
const USERNAME_KEY = 'nexios.chat.username'
const SURVEY_KEY = 'nexios.chat.survey'
const USER_MODE_STARTED_KEY = 'nexios.chat.chatMode'
const CALL_RECEIVED_KEY = 'nexios.chat.callreceived'
const SURVEY_STARTED_KEY = 'nexios.chat.startedSurvey'
const DEVICE_SETTINGS_KEY = 'nexios.chat.deviceSettings'

const logo = ()=>(
  <a href='https://nexios.cc/' target='_blank' class='logo-wrapper'>
    <img src='https://app.nexios.io/images/logo.png' class='logo' />
  </a>
)
const defaultStyle = {
  '--heading-color': '#4f6780',
  '--subheading-color': '#ffbb33',
  '--msg-bubble-in-bg': '#F4F4F4',
  '--msg-bubble-in-txt': '#1e1f2d',
  '--msg-bubble-in-time': '#959595',
  '--msg-bubble-out-bg': '#4F6780',
  '--msg-bubble-out-txt': '#EFEFEF',
  '--msg-bubble-out-time': '#16293e',
  '--msg-bubble-chatbot-bg': '#ffbb33',
  '--msg-bubble-chatbot-txt': '#1e1f2d',
  '--msg-bubble-chatbot-time': '#92650b',
  '--button-bg': '#ffbb33',
  '--button-txt': '#1e1f2d',
  '--chatbot-button-bg': '#ffbb33',
  '--chatbot-button-fg': '#4f6780',
  '--avatar-icon-color': '#ffbb33',
  '--checkbox-bg': '#ffbb33',
  '--checkbox-fg': '#1e1f2d',
  '--main-font': 'Inter',
  '--chat-window-radius': '12px',
  '--chat-buttons-radius': '12px'
}

export class ChatBox extends Jsx6old {
  /** @type {ChatOptions}*/
  options
  body
  parentWindow
  parentFrame
  surveyBotStored
  /** @type {string} */
  lang

  /**
   *
   * @param {Element} body
   * @param {Window} parentWindow
   * @param {ChatOptions} options
   * @param {Element} parentFrame
   * @param {import('./ScreenType.js').ScreenType} screenType
   */
  constructor (body, parentWindow, parentFrame, screenType) {
    super()
    this.body = body
    this.parentWindow = parentWindow
    this.parentFrame = parentFrame
    this.screenType = screenType
    this.t = t
    this.fileUploadConf = null
    this.$s.unavailableMsg = ''
  }
  
  setStyle(key, value){
    this.el.style.setProperty(key, value)
  }
  
  /**
   *
   * @param {ChatOptions} options
   */
  initChat (options) {
    // console.warn('options', options)
    this.chatBotName = options.chatBotName || t('chatbot')
    this.chatbotKnowledge = false
    this.transferedToAgent = false
    if(!options.userMode && options.chatType) options.userMode = options.chatType
    if (options.topics?.length === 1 && (options.topics[0] === '' || !options.topics[0])) {
      options.topics = null
    }
    const style = options.style || {}
    for(let p in defaultStyle){
      this.el.style.setProperty(p, style[p] || defaultStyle[p])
    }
    this.receivedMessageFromChatbot = false
    this.sentAnyMessage = false
    this.sentHandledCommand = false
    
    this.options = options
    if(!this.options?.optionHideLogo) this.$s.logo(logo)
    this.settingsWatchersInitialized = false
    this.baseHeight = null
    this.userFailedFormValidation = false
    this.visibleGroup = 'button'
    this.surveyBotStored = {}
    this.videoStreamingActive = false
    this.hasBot = false
    // when chatFinished is true we disable sending message
    this.chatFinished = false
    this.answersInSurvey = []

    setVisible(this.startBubble, this.displayStartBubble())
    this.showButtons(options.startup == 'buttons' ? options : [])
    this.agentEneteredChat = false
    /** turnOffLocalStorage
    this.chatStoreKey = makeKey(Date.now())
    var chatStored = localStorage.getItem(this.chatStoreKey)

    if (!chatStored) {
      // check yesterday
      this.chatStoreKey = makeKey(Date.now() - 1000 * 60 * 60 * 24)
      chatStored = localStorage.getItem(this.chatStoreKey)

      if (!chatStored) this.chatStoreKey = makeKey(Date.now()) // if there is no stored chat yesterday, use today key
    }

    if (chatStored && chatStored[ 0 ] == '{') {
      try {
        chatStored = JSON.parse(chatStored)
        const agentDataMessages = chatStored.messages?.filter(message => message.type === 'AGENT')
        const agentDataMessage = agentDataMessages?.length ? agentDataMessages[ agentDataMessages.length - 1 ] : {}
        this.setAgentNickname(agentDataMessage.name || '')

        const surveyStored = localStorage.getItem(SURVEY_KEY)
        if (surveyStored && surveyStored[ 0 ] == '{') {
          this.survey = JSON.parse(surveyStored)
          this.setSurvey()
        }
        this.initSettingsWatchers()
      } catch (e) {
        console.error(e)
      }
    } else {
      chatStored = {}
    }

    if (!chatStored.chatId) chatStored = {}
    chatStored.members = chatStored.members || []
    chatStored.messages = chatStored.messages || []

    if (!chatStored.chatId) chatStored.chatId = this.options.idInit
    this.chatStored = chatStored
    */

    this.setFormInitialData()

    /** turnOffLocalStorage
    if (chatStored.chatId != this.options.idInit) {
      this.startChatSession(false)
      chatStored.messages.forEach(m => this.addChatMessage(m))
      setVisible(this.areaVideo, 0)
      this.restore()
    } else*/
    if (this.options.startup === 'chat' && !options.isPreview) {
      this.start(this.options.userMode)
    }

    this.chatName = t('me')
    this.surveySections = []

    this.chatMessageInput.addEventListener('keypress', evt => {
      if (evt.keyCode == 13 && !evt.shiftKey) {
        evt.preventDefault()
        this.sendChatMessage()
      }
    })
    this.fileUploadField.addEventListener('change', evt => {
      this.uploadFile(this.fileUploadField.files?.[0])
    })

    if (INVITE.invite) {
      console.log("INIVITE ME ")
      this.body.classList.add('invite')
      this.initSettings(INVITE.video, INVITE.audio, this.options.deviceSelectionForm)
    }

    const resizeObserver = new ResizeObserver(entries => {
      var rect = entries[ 0 ].contentRect
      this.resize(rect.width, rect.height)
    })

    this.deviceErrorBtn.addEventListener('click', () => {
      setVisible(this.area.DevicesError, false)

      this.setFormInitialData()
      this.hideFormValidationMessages()
      this.userFailedFormValidation = false
      setVisible(this.area.button, true)

      this.visibleGroup = 'button'
      this.resize()
    })

    this.generalErrorBtn?.addEventListener('click', () => {
      setVisible(this.area.GeneralError, false)

      this.setFormInitialData()
      this.hideFormValidationMessages()
      this.userFailedFormValidation = false
      setVisible(this.area.button, true)

      this.visibleGroup = 'button'
      this.resize()
    })

    window.addEventListener('focus', () => {
      this.checkIfShouldReinitialize()
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'hidden') {
        this.checkIfShouldReinitialize()
      }
    });
    
    window.addEventListener("unload", () => {
      let msg = {from: this.fromnUri, time: Date.now(), type: 'LEAVE'}
      msg = JSON.stringify(msg)
      const target = SIP.UserAgent.makeURI('sip:' + this.chatStored.chatId + '@nexios')
      new SIP.Messager(this.sipUser, target, msg).message()
      //turnOffLocalStorage localStorage.removeItem(this.chatStoreKey)
      this.chatEnded()
    });
    

    resizeObserver.observe(this.el)

    // this.items.tel.addEventListener('input', () => {
    //   setValue(this.items.tel, cleanupPhoneNumber(this.items.tel.value, true))
    // })

    const form = this.area.form
    const inputs = form.querySelectorAll('input')
    inputs.forEach(input => {
      const eventToListen = input.type === 'checkbox' ? 'click' : 'keyup'
      input.addEventListener(eventToListen, (event) => {
        // Start validation on user input only after user has submitted form and failed validation - at that
        // moment all failed fields are marked as invalid
        if (this.userFailedFormValidation) {
          this.validateForm()
        }
      })
    })
    if (!this.topicIsFreeTextField()) {
      this.topicNLB.addEventListener('change', (event) => {
        if (this.userFailedFormValidation) {
          this.validateForm()
        }
      })
    }

    // let areaFormBtn = this.area.form.querySelector("[p='bt.minimize']")

    // if (options.startup == 'chat') areaFormBtn.setAttribute('hidden', true)
    // else areaFormBtn.removeAttribute('hidden')

    setVisible(this.topic, !options.topics)
    setVisible(this.topicNLB, options.topics)

    if(options.type && !options.isPreview){
      let type = options.type === 'text' ? 'chat' : options.type
      this.start(type)
    }
    
    if(options.isPreview){
      this.started = true
      this.addChatMessage()
      this.updateWelcomeMessage('chat')
      // Todo constante
      this.survey = {
        'id': 19,
        'type': 'SURVEY',
        'name': 'SurveyAAAA',
        'intro': 'test',
        'templateAlarm': '65096c543cfc11702a0c1ef1',
        'alarmEC': 4,
        'introTrans': {},
        'questions': [{
          'id': 1,
          'name': 'Oj ej',
          'label': 'Satisfaction',
          'type': 'RATE',
          'showOnGraph': true,
          'labelTrans': {},
          'shortCode': 'prvo',
          'target': 75,
          'alarm': 2,
          'shortCodeTrans': {},
          'answers': [{ 'id': 1, 'answer': '1', 'tone': '1' }, { 'id': 2, 'answer': '2', 'tone': '2' }, {
            'id': 3,
            'answer': '3',
            'tone': '3',
          }, { 'id': 4, 'answer': '4', 'tone': '4' }, { 'id': 5, 'answer': '5', 'tone': '5' }],
          'options': [],
          'optionsTrans': [],
          'nps': false,
          'answersGroups': [{ 'id': 1, 'label': 'Satisfied', 'min': 4, 'max': 6, 'trans': {} }],
        }, {
          'id': 2,
          'name': 'Drugo',
          'label': 'Kako želite da vas naknadno kontaktiramo?',
          'type': 'OPTIONS',
          'showOnGraph': true,
          'labelTrans': {},
          'shortCode': 'drugo',
          'target': 80,
          'alarm': 2,
          'shortCodeTrans': {},
          'answers': [{ 'id': 1, 'answer': 'Mobitel', 'tone': '1' }, {
            'id': 2,
            'answer': 'Email',
            'tone': '2',
          }, { 'id': 3, 'answer': 'Viber', 'tone': '3' }, { 'id': 4, 'answer': 'cetvrti', 'tone': '4' }],
          'options': ['prvi', 'drugi', 'treci', 'cetvrti'],
          'optionsTrans': [],
          'nps': false,
          'answersGroups': [{ 'id': 1, 'label': 'Satisfied', 'min': 0, 'max': 0, 'trans': {} }],
        }, {
          'id': 3,
          'name': 'treci',
          'label': 'treci',
          'type': 'NUMERIC',
          'showOnGraph': true,
          'labelTrans': {},
          'shortCode': 'tri',
          'target': 80,
          'alarm': 0,
          'shortCodeTrans': {},
          'answers': [{ 'id': 1, 'answer': '1', 'tone': '1' }, { 'id': 2, 'answer': '2', 'tone': '2' }, {
            'id': 3,
            'answer': '3',
            'tone': '3',
          }, { 'id': 4, 'answer': '4', 'tone': '4' }, { 'id': 5, 'answer': '5', 'tone': '5' }],
          'options': [],
          'optionsTrans': [],
          'nps': true,
          'answersGroups': [{
            'id': 1,
            'label': 'Detractors',
            'min': 0,
            'max': 2,
            'key': 'DET',
            'trans': {},
          }, { 'id': 2, 'label': 'Passives', 'min': 3, 'max': 3, 'key': 'PASS', 'trans': {} }, {
            'id': 3,
            'label': 'Promotors',
            'min': 4,
            'max': 5,
            'key': 'PROM',
            'trans': {},
          }],
        }, {
          'id': 4,
          'name': 'Vase misljenje',
          'label': 'Vase misljenje',
          'type': 'FREE_TEXT',
          'showOnGraph': false,
          'labelTrans': {},
          'shortCode': 'misljenje',
          'shortCodeTrans': {},
          'answers': [],
          'options': [],
          'optionsTrans': [],
          'nps': false,
          'answersGroups': [],
        }],
        'items': [{
          'id': 1,
          'name': 'Prvo',
          'label': 'Koliko ste zadovoljni uslugom?',
          'type': 'RATE',
          'showOnGraph': true,
          'labelTrans': {},
          'shortCode': 'prvo',
          'target': 75,
          'alarm': 2,
          'shortCodeTrans': {},
          'answers': [{ 'id': 1, 'answer': '1', 'tone': '1' }, { 'id': 2, 'answer': '2', 'tone': '2' }, {
            'id': 3,
            'answer': '3',
            'tone': '3',
          }, { 'id': 4, 'answer': '4', 'tone': '4' }, { 'id': 5, 'answer': '5', 'tone': '5' }],
          'options': [],
          'optionsTrans': [],
          'nps': false,
          'answersGroups': [{ 'id': 1, 'label': 'Satisfied', 'min': 4, 'max': 6, 'trans': {} }],
        }, {
          'id': 2,
          'name': 'Drugo',
          'label': 'Kako želite da vas naknadno kontaktiramo?',
          'type': 'OPTIONS',
          'showOnGraph': true,
          'labelTrans': {},
          'shortCode': 'drugo',
          'target': 80,
          'alarm': 2,
          'shortCodeTrans': {},
          'answers': [{ 'id': 1, 'answer': 'E-mail', 'tone': '1' }, {
            'id': 2,
            'answer': 'drugi',
            'tone': '2',
          }, { 'id': 3, 'answer': 'Telefon', 'tone': '3' }, { 'id': 4, 'answer': 'Viber', 'tone': '4' }],
          'options': ['Telefon', 'E-mail', 'Viber', 'Whatsapp'],
          'optionsTrans': [],
          'nps': false,
          'answersGroups': [{ 'id': 1, 'label': 'Satisfied', 'min': 0, 'max': 0, 'trans': {} }],
        }, {
          'id': 3,
          'name': 'treci',
          'label': 'Ocijenite koliko smo vam pomogli sa vašim zahtjevom.',
          'type': 'NUMERIC',
          'showOnGraph': true,
          'labelTrans': {},
          'shortCode': 'tri',
          'target': 80,
          'alarm': 0,
          'shortCodeTrans': {},
          'answers': [{ 'id': 1, 'answer': '1', 'tone': '1' }, { 'id': 2, 'answer': '2', 'tone': '2' }, {
            'id': 3,
            'answer': '3',
            'tone': '3',
          }, { 'id': 4, 'answer': '4', 'tone': '4' }, { 'id': 5, 'answer': '5', 'tone': '5' }],
          'options': [],
          'optionsTrans': [],
          'nps': true,
          'answersGroups': [{
            'id': 1,
            'label': 'Detractors',
            'min': 0,
            'max': 2,
            'key': 'DET',
            'trans': {},
          }, { 'id': 2, 'label': 'Passives', 'min': 3, 'max': 3, 'key': 'PASS', 'trans': {} }, {
            'id': 3,
            'label': 'Promotors',
            'min': 4,
            'max': 5,
            'key': 'PROM',
            'trans': {},
          }],
        }, {
          'id': 4,
          'name': 'Vase misljenje',
          'label': 'Vase misljenje',
          'type': 'FREE_TEXT',
          'showOnGraph': false,
          'labelTrans': {},
          'shortCode': 'misljenje',
          'shortCodeTrans': {},
          'answers': [],
          'options': [],
          'optionsTrans': [],
          'nps': false,
          'answersGroups': [],
        }],
        'lastId': null,
        'defLang': 'en',
        'orgUnitId': 1,
        'slots': { 'slot1': 3, 'slot2': 1, 'slot3': 2 },
        'sendButtonText': 'Salji',
        'sendButtonTextTrans': {},
        'thankYouText': 'Hvala',
        'thankYouTextTrans': {},
      }
      this.setSurvey()

      this.el.setAttribute('isPreview', true)
    }
  }

  setFormInitialData () {
    var data = this.options.formData || {}

    /** turnOffLocalStorage
    var dataStr = localStorage.getItem(FORM_DATA_KEY)
    if (dataStr) data = JSON.parse(dataStr)
    */

    // Set default value for every form field if it doenst exist. Boolean false for checkbox, empty string for all other.
    for (const [ key, value ] of Object.entries(this.items)) {
      if (data[ key ] === undefined) {
        data[ key ] = value.type === 'checkbox' ? false : ''
      }
    }

    this.populateTopicsList()
    setValue(this.items, data)
    setValue(this.topic, data.topic || '')
    setValue(this.topicNLB, data.topicNLB || '')
    setVisible(this.errorTerms, false)
  }

  
  checkIfShouldReinitialize(){
    if(this.started){
      setTimeout(()=>{
        this.remoteVideo.play()
        this.localVideo.play()
      })
    }
  }
  
  showButtons (options = []) {
    let chatButtons = options.chatButtons || []
    let chatType = options.type

    setVisible(this.buttonStartText, chatButtons.includes('text') && ((chatType && chatType === 'text') || !chatType))
    setVisible(this.buttonStartAudio, chatButtons.includes('audio') && ((chatType && chatType === 'audio') || !chatType))
    setVisible(this.buttonStartVideo, chatButtons.includes('chat_video') && ((chatType && chatType === 'chat_video') || !chatType))
    setVisible(this.buttonStartVideoId, chatButtons.includes('chat_video_id') && ((chatType && chatType === 'chat_video_id') || !chatType))
  }

  initSettings (isVideo, isAudio, showForm, startup) {
    console.log("INIT SETTINGS")
    this.isVideo = isVideo
    this.isAudio = isAudio

    // allows for start directly into chat window, so user can use video right away
    // and then change settings if needed
    this.visibleIs(showForm ? 'settings' : 'chat')
    this.getMediaDevices(() => {

      setVisible(this.area2.audioIn, this.isAudio)
      setVisible(this.area2.audioOut, this.isAudio)
      setVisible(this.area2.videoIn, this.isVideo)
      setVisible(this.area2.settingsVideo, this.isVideo)

      this.initSettingsWatchers()

      if (this.isVideo) {
        setVisible(this.videoDialog, 1)
        setTimeout(() => this.applyVideo(), 200)
      }
    })
  }

  initSettingsWatchers () {
    if (this.settingsWatchersInitialized) {
      return
    }

    this.settings.videoIn.addEventListener('change', e => {
      this.updateDeviceSettings('videoIn')
    })
    this.settings.audioIn.addEventListener('change', e => {
      this.updateDeviceSettings('audioIn')
    })
    this.settings.audioOut.addEventListener('change', e => {
      this.updateDeviceSettings('audioOut')
    })

    this.settingsWatchersInitialized = true
  }

  getMediaDevices (callback) {
    const self = this
    try {
      navigator.mediaDevices
        .enumerateDevices()
        .then(devs => {
          const audioOutputDevices = this.processAndGetAudioOutputDevices(devs)

          fillSelect(this.settings.audioIn, devs.filter(dev => dev.kind == 'audioinput').map(deviceOption))
          fillSelect(this.settings.audioOut, audioOutputDevices)
          fillSelect(this.settings.videoIn, devs.filter(dev => dev.kind == 'videoinput').map(deviceOption))
          callback()
        })
        .catch(function(err) {
          self.mediaDevicesError(true)
        })
    } catch (e) {
      self.mediaDevicesError(true)
    }
  }

  /**
   * Filters the list of available devices to only include audio output devices, and returns an array of options for each audio
   * output device. If there are no audio output devices, returns an array containing the default audio output device.
   *
   * This is necessary because Firefox does not provide a list of audio output devices by default. To allow selection of a specific
   * audio output device, the 'media.setsinkid.enabled' configuration option needs to be set to 'true', which is not the default setting in Firefox.
   *
   * Additionally, if there are no audio output devices and if user is using Firefox on desktop device, display instructions
   * how to set 'media.setsinkid.enabled' configuration option to 'true'
   *
   * @param {MediaDeviceInfo[]} allDevices - The list of available media devices
   * @returns {Object[]} An array of options for each audio output device
   */
  processAndGetAudioOutputDevices (allDevices) {
    const audioOutputDevicesList = allDevices.filter(device => device.kind == 'audiooutput')
    const useDefaultAudioOutputDevice = audioOutputDevicesList.length === 0

    const userAgent = navigator.userAgent.toLowerCase()
    setVisible(this.setSinkIdInstructions, useDefaultAudioOutputDevice && userAgent.indexOf('firefox') > -1 && userAgent.indexOf('mobile') === -1)

    if (useDefaultAudioOutputDevice) {
      return [ { id: '', text: t('system_default_speaker_device'), isDefault: true } ]
    }

    return audioOutputDevicesList.map(deviceOption)
  }

  applyVideo () {
    this.cleanupLocalStream()
    navigator.mediaDevices
      .getUserMedia({ video: { deviceId: { exact: this.settings.videoIn.value } } })
      .then(stream => {
        this.localStream = trackStream(stream)
        this.localVideo.srcObject = stream
        this.localVideo.play()
      })
      .catch(err => {
      })
  }

  moveVideo (code) {
    if (code == 'settings') {
      setVisible(this.formVideoDialog, 1)
      this.area2.settingsVideo.appendChild(this.localVideo)
    } else if (code == 'chat') {
      setVisible(this.area2.chatVideoOut, false)
      this.area2.chatVideoOut.appendChild(this.localVideo)
      this.area2.chatVideoIn.appendChild(this.remoteVideo)
      setVisible(this.area2.chatVideoIn, !!this.remoteVideo.srcObject)
      setTimeout(()=> {
        this.area2.chatVideoOut.classList.remove('animateVideoOut')
        this.area2.chatVideoOut.classList.add('fx')
        setVisible(this.area2.chatVideoOut, true)
      }, 100)
    } else if (code == 'form') {
      setVisible(this.formVideoDialog, 0)
      this.formVideoDialog.appendChild(this.localVideo)
    }
  }

  visibleIs (code) {
    if(this.options.isPreview && code === 'dialog'){
      this.clear()
      this.addChatMessage(null, null, true)
      this.hasBot = true
    }
    
    if(this.options.isPreview && code === 'chat') {
      this.clear()
      this.addChatMessage(null, null, false)
      this.setAgentNickname('Agent')
      this.hasBot = false
    }
    
    if(this.options.isPreview && code === 'dialog'){
      code = 'chat'
      this.setAgentNickname()
      this.hasBot = true
    }
    this.visibleGroup = code
    // since deviceSelection module is shared between settings and "session settings", we must append it back to settings if it doesn't exist
    if (code === 'settings' && !this.deviceSelectionWrapper.querySelector('[p="setting.deviceSelection"]')) {
      this.deviceSelectionWrapper.appendChild(this.setting.deviceSelection)
    }
    
    setVisible(this.area, code)
    this.moveVideo(code)
    fireCustom(this.el, 'chatvisible', { visible: code != 'button' })
  }

  topicIsFreeTextField () {
    return !this.options.topics?.length
  }

  isStartBubble () {
    return this.options.startBubble
  }

  getTermsUrl () {
    return this.options.terms
  }

  displayStartBubble () {
    if (!this.isStartBubble()) {
      return 0
    }

    return readCookie('chatBubbleHidden') == 'yes' ? 0 : 1
  }

  /**
   * Initialize chat and prepare all settings, screens and messages.
   *
   * Additionaly, if it's an video chat, initializes devices and media streams to check if user has available devices
   * for media streaming. If true, continues with process (display device selection form, or auto-starts chat - depending
   * on settings). If false, displays error message to user that media devices are not available.
   *
   * @param {string} userMode String representing if initialization is done for chat, chat_video, chat_video_id or audio
   * @param {boolean} afterForm Information if initialization process is started after user has populated form with personal data.
   */
  start (userMode, afterForm = false) {
    if(this.options.isPreview){
      return 
    }
    // if(iosMobileReg.test(navigator.platform) || this.options.DEV_MODE){
    if(this.screenType.Mobile || this.screenType.Tablet){
      if(!this.__audio){
        this.__audio = new Audio(localUrl(this.options.silence || '/silence.wav'));
        this.__audio.loop = true
      }
      this.__audio.play();
    }

    // 3931 commented out and handling inside handleMessage
    // if (!this.options.working && this.options.notWorkingMessage) {
    //   let errMsg = this.options.notWorkingMessage ? this.options.notWorkingMessage : t('outside_working_hours')
    //   // this.errorText.innerHTML = `<span>${nl2br(this.options.notWorkingMessage)}</span>`
    //   console.warn(errMsg)
    //   this.errorText.innerHTML = `<span>${errMsg}</span>`
    //   setVisible(this.startBubble, false)
    //   this.visibleIs('error')
    //   return
    // }

    userMode = this.parseUserMode(userMode)
    this.options.userMode = this.parseUserMode(this.options.userMode)
    this.options.userMode = this.options.startup === 'chat' ? this.options.userMode : ''
    this.updateWelcomeMessage((this.options.userMode || userMode))
    this.userMode = userMode
    if (this.started) {
      this.restore()

      return
    }

    if (!afterForm && this.options.contactDataForm) {
      this.showForm()

      return
    }

    //turnOffLocalStorage localStorage.setItem(USER_MODE_STARTED_KEY, userMode)
    if (this.options.userMode === 'chat' || userMode === 'chat') {
      this.startChatSession(true)

      return
    }

    if (afterForm && !this.validateForm()) {
      this.userFailedFormValidation = true
      return
    }
    
    if (userMode === 'audio') {
      this.callType = userMode
    }

    if (this.isVideoCall() || this.isAudioCall()) {
      if (this.options.deviceSelectionForm) {
        this.formLoader(true)
      }

      this.initMediaStream(() => {
        this.formLoader(false)
        this.initSettings(this.isVideoCall(), 1, this.options.deviceSelectionForm, true)
        if (!this.options.deviceSelectionForm) {
          this.startChatSession(true)
        }
      })
    }
  }

  /**
   * Parses and validates the provided user mode.
   *
   * @param {string} userMode - The user mode to be parsed and validated.
   * @returns {string} - Returns the provided user mode if it is valid; otherwise, defaults to 'chat'.
   */
  parseUserMode(userMode) {
    const availableModes = ['chat', 'audio', 'chat_video', 'chat_video_id']
    
    return availableModes.includes(userMode) ? userMode : 'chat'
  }
  
  formLoader(loading) {
    setVisible(this.loading, loading)
  }

  initMediaStream (callback) {
    this.cleanupLocalTracks()

    try {
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: this.isVideoCall() })
        .then(stream => {
          this.cleanupLocalStream()
          this.localStream = trackStream(stream)
          this.videoFirst = false
          this.videoAutoAnswer = true
          callback()
        })
        .catch(err => {
          this.mediaDevicesError(true)
        })
    } catch (e) {
      this.mediaDevicesError(true)
    }
  }

  updateWelcomeMessage (type) {
    let typeMsg = type
    if(this.options.isPreview){
      typeMsg = 'chat'
    }
    this.welcomeMsg.innerText = t('welcome_' + typeMsg)
    this.area.form.querySelector('button[p=\'bt.start\']').innerText = (typeMsg && typeMsg.includes('video')) ? t('next') : t('start_' +typeMsg)
    this.area.settings.querySelector('button[p=\'bt.start\']').innerText = t('start_' +typeMsg)
    this.formWelcomeMessage.classList.remove('chat')
    this.formWelcomeMessage.classList.remove('chat_video')
    this.formWelcomeMessage.classList.remove('chat_video_id')
    this.formWelcomeMessage.classList.add(typeMsg)
  }

  restore () {
    this.handleChatStarted(true)
    if (this.started) {
      let visibleArea = 'chat'
      /** turnOffLocalStorage
      if (this.chatStored?.state === 'HANDLED') {
        visibleArea = localStorage.getItem(SURVEY_STARTED_KEY) === 'yes' ? 'survey' : 'question'
      }
      */

      // this.visibleIs(visibleArea)
      if (visibleArea === 'chat') {
        this.videoChatRestored()
      }
    } else {
      setVisible(this.startBubble, this.displayStartBubble())

      if (this.topicIsFreeTextField()) {
        setVisible(this.topic, 1)
        setVisible(this.topicLabel, 1)
        setVisible(this.topicNLB, 0)
        setVisible(this.topicNlbLabel, 0)
      } else {
        setVisible(this.topic, 0)
        setVisible(this.topicLabel, 0)
        setVisible(this.topicNLB, 1)
        setVisible(this.topicNlbLabel, 1)
      }

      this.showForm()
    }
  }

  populateTopicsList () {
    if (this.topicIsFreeTextField()) {
      return
    }

    let topicsList = this.options.topics.map((name, id) => {
      return {
        id,
        name,
      }
    })

    topicsList.unshift({ id: '', name: t('select_topic_nlb') })

    fillSelect(this.topicNLB, topicsList)
    this.topicNLB.options[ 0 ].disabled = true
    let existingTopicOption = topicsList.find((topic)=>topic.name === this.options.formData.topic)
    if(existingTopicOption){
      setTimeout(()=>{
        setValue(this.topicNLB, existingTopicOption.id )
      })
    }
  }

  populateLangList () {
    let langList = [
      {id: 'en', name: t('en')},
      {id: 'hr', name: t('hr')},
      {id: 'si', name: t('si')},
    ]
    // fillSelect(this.items.lang, langList)
  }

  startInvite (newChat) {
    this.startChatSession(true)
  }

  showForm () {
    if (this.options.contactDataForm) {
      if (this.topicIsFreeTextField()) {
        setVisible(this.topic, 1)
        setVisible(this.topicLabel, 1)
        setVisible(this.topicNLB, 0)
        setVisible(this.topicNlbLabel, 0)
      } else {
        setVisible(this.topic, 0)
        setVisible(this.topicLabel, 0)
        setVisible(this.topicNLB, 1)
        setVisible(this.topicNlbLabel, 1)
      }

      this.visibleIs('form')

      if (this.getTermsUrl()) {
        setVisible(this.termsWrapper, 1)
        this.termsUrl.setAttribute('href', this.getTermsUrl())
        if (t('gdpr_link') !== 'gdpr_link') {
          setVisible(this.gdprWrapper, 1)
          this.gdprUrl.setAttribute('href', t('gdpr_link'))
        }
        this.resize()
      }
    } else {
      this.visibleIs('chat')
    }
  }

  validateForm () {
    this.hideFormValidationMessages()
    let name = INVITE.invite ? undefined : this.items.name.value
    let email = INVITE.invite ? undefined : this.items.email.value
    let tel = INVITE.invite ? undefined : this.items.tel.value
    let terms = INVITE.invite ? undefined : this.items.terms.checked
    let topicNLB = INVITE.invite ? undefined : this.topicNLB.value

    let formValidation = !INVITE.invite && this.options.contactDataForm
    let isValid = true
    
    if (!name && formValidation && this.options.optionName) {
      isValid = false
      setVisible(this.errorName, !name)
      classIf(this.items.name, 'error-style', !name)
    }

    if (formValidation) {
      email = typeof email === 'string' ? email.trim() : email
      tel = cleanupPhoneNumber(tel)
      
      let emailOrPhone = this.options.optionEmail && this.options.optionPhone
      let checkEmail = emailOrPhone && !email && tel ? false : true
      let checkTel = emailOrPhone && email && !tel ? false : true

      if(!email && this.options.optionEmail && checkEmail){
        isValid = false
        this.items.email.classList.add('error-style')
        setVisible(this.errorEmail, true)
      }
      
      if(!tel && this.options.optionPhone && checkTel){
        isValid = false
        this.items.tel.classList.add('error-style')
        setVisible(this.errorTel, true)
      }

      const email_reg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,20})?$/
      const emailValid = email_reg.test(email)
      if (email && !emailValid) {
        this.items.email.classList.add('error-style')
        isValid = false
        setVisible(this.errorEmailFilter, true)
      }

      const telIsValid = validatePhoneNumber(tel)
      if (tel && !telIsValid) {
        this.items.tel.classList.add('error-style')
        isValid = false
        setVisible(this.errorTel, true)
      }

      if (!this.topicIsFreeTextField() && !topicNLB) {
        this.topicNLB.classList.add('error-style')
        isValid = false
        setVisible(this.errorTopic, true)
      }
    }

    if (!terms && formValidation && this.getTermsUrl()) {
      setVisible(this.errorTerms, true)
      this.items.terms.classList.add('error-terms')
      isValid = false
    }

    return isValid
  }

  hideFormValidationMessages () {
    classIf(this.items.name, 'error-style', false)
    setVisible(this.errorName, false)

    classIf(this.items.email, 'error-style', false)
    setVisible(this.errorEmail, false)
    setVisible(this.errorEmailFilter, false)

    classIf(this.items.tel, 'error-style', false)
    setVisible(this.errorTel, false)

    classIf(this.topicNLB, 'error-style', false)
    setVisible(this.errorTopic, false)

    if (this.getTermsUrl()) {
      classIf(this.items.terms, 'error-style', false)
      setVisible(this.errorTerms, false)
    }

  }

  /**
   * If video session shoule be restored, and videoArea is not visible, initializes the media stream, makes the
   * video area visible and applies the selected video device.
   */
  videoChatRestored () {
    if (this.shouldVideoSessionBeRestored() && !isVisible(this.areaVideo)) {
      this.getMediaDevices(() => {
        setValue(this.settings.videoIn, this.getDeviceIdFromLocalStorage('videoIn'))
        setValue(this.settings.audioIn, this.getDeviceIdFromLocalStorage('audioIn'))

        this.initMediaStream(() => {
          setVisible(this.areaVideo, 1)
          this.applyVideo()
        })
      })
    }
  }

  /**
   * Checks if the conditions are met to initiate a video session. In practice, those conditions are met when user
   * refreshed page after video or videoId chat is started, but no agent has taken chat from queue.
   *
   * Checks two conditions:
   * 1. if the user started the chat in video mode by checking if the USER_MODE_STARTED_KEY is set to either 'chat_video'
   *    or 'chat_video_id', and if
   * 2. if there was no incoming call from agent for this session.
   */
  shouldVideoSessionBeRestored () {
    /** turnOffLocalStorage
    if (
      [ 'chat_video', 'chat_video_id' ].indexOf(localStorage.getItem(USER_MODE_STARTED_KEY)) !== -1
      &&
      !localStorage.getItem(CALL_RECEIVED_KEY)
    ) {
      return true
    }
    */

    return false
  }

  getDeviceIdFromLocalStorage (device) {
    let deviceId = ''
    /** turnOffLocalStorage
    try {
      const deviceSettingsString = localStorage.getItem(DEVICE_SETTINGS_KEY)
      if (deviceSettingsString && deviceSettingsString[ 0 ] == '{') {
        const deviceSettings = JSON.parse(deviceSettingsString)
        deviceId = deviceSettings[ device ]
      }
    } catch (e) {
    }
    */

    return deviceId
  }

  mediaDevicesError (isVideo) {
    const message = isVideo ? t('camera_or_microphone_not_detected') : t('microphone_not_detected')
    this.deviceErrorMsg.innerHTML = message

    setVisible(this.area.DevicesError, true)
    setVisible(this.area.button, false)
    setVisible(this.area.form, false)
    this.formLoader(false)
    setVisible(this.area.settings, false)

    this.visibleGroup = 'DevicesError'
    this.resize()
  }

  generalError (message) {
    message = message || t('general_error')
    this.generalErrorMsg.innerHTML = message

    setVisible(this.area.GeneralError, true)
    setVisible(this.area.button, false)
    setVisible(this.area.form, false)
    this.formLoader(false)
    setVisible(this.area.settings, false)

    this.visibleGroup = 'GeneralError'
    this.resize()
  }

  startAfterForm () {
    this.start(this.userMode || this.options.userMode, true)
  }

  startChatSession (newChat) {
    if(this.options.ping) this.startPing()
    /** turnOffLocalStorage
    if (!newChat && localStorage.getItem(DEVICE_SETTINGS_KEY)) {
      this.getMediaDevices(() => {
        const storedVideoIn = this.getDeviceIdFromLocalStorage('videoIn')
        if (storedVideoIn) {
          setValue(this.settings.videoIn, storedVideoIn)
        }

        const storedAudioIn = this.getDeviceIdFromLocalStorage('audioIn')
        if (storedAudioIn) {
          setValue(this.settings.audioIn, storedAudioIn)
        }

        const storedAudioOut = this.getDeviceIdFromLocalStorage('audioOut')
        if (storedAudioOut) {
          setValue(this.settings.audioOut, storedAudioOut)
        }
      })
    }
    */

    //turnOffLocalStorage if (!localStorage.getItem(DEVICE_SETTINGS_KEY)) {
      const deviceSettings = {
        audioIn: this.settings.audioIn.value,
        audioOut: this.settings.audioOut.value,
        videoIn: this.settings.videoIn.value,
      }
      //turnOffLocalStorage localStorage.setItem(DEVICE_SETTINGS_KEY, JSON.stringify(deviceSettings))
    //turnOffLocalStorage }

    if (this.videoFirst) {
      this.videoFirst = false
      if (this.topicIsFreeTextField()) {
        setVisible(this.topic, 1)
        setVisible(this.topicLabel, 1)
        setVisible(this.topicNLB, 0)
        setVisible(this.topicNlbLabel, 0)
      } else {
        setVisible(this.topic, 0)
        setVisible(this.topicLabel, 0)
        setVisible(this.topicNLB, 1)
        setVisible(this.topicNlbLabel, 1)
      }

      this.showForm()
      this.moveVideo('form')
      setVisible(this.areaVideo, true)
      this.applyVideo()

      return
    }

    const formIsValid = this.validateForm()
    if (!formIsValid) {
      this.userFailedFormValidation = true
    }

    if (formIsValid) {
      setVisible(this.areaVideo, this.userMode === 'chat' || this.userMode === 'audio' ? 0 : 1)
      this.handleChatStarted(true)
      setVisible(this.sendboxWrapper, true)
      setVisible(this.chatEnd, true)
      setVisible(this.surveyButtonWrapper, false)
      setVisible(this.closeButtonWrapper, false)
      this.visibleIs('chat')
      this.started = true

      let topic
      if (!INVITE.invite) {
        if (this.topicIsFreeTextField()) {
          topic = this.topic ? this.topic.value : undefined
        } else {
          var sel = this.topicNLB
          topic = sel.options[ sel.selectedIndex ]?.text
        }
      }

      // if(INVITE.invite) {
      // 	if(newChat) setTimeout(()=>this.handleRinging(), 500);
      // 	return;
      // }
      const { sessionUser } = this.options
      var username = sessionUser + Math.random() + 'xNEX'
      
      // for now, sessions are not restored
      // var username = localStorage.getItem(USERNAME_KEY)
      // if (!username || username.indexOf('xNEX') == -1 || !username.startsWith(sessionUser)) {
      //   username = sessionUser + Math.random() + 'xNEX'
      //   localStorage.setItem(USERNAME_KEY, username)
      // }

      var details = (this.details = INVITE.invite ? {} : formData(this.items))
      details.tel = cleanupPhoneNumber(details.tel)
      this.details = details = { ...this.options.formData, ...details }
      details.url = this.parentWindow.document.location.toString()
      details.topic = topic
      details.topicNLB = this.topicNLB.value
      //turnOffLocalStorage localStorage.setItem(FORM_DATA_KEY, JSON.stringify(details))
      details.userMode = this.userMode //turnOffLocalStorage this.shouldVideoSessionBeRestored() ? localStorage.getItem(USER_MODE_STARTED_KEY) : this.userMode
      details.lang = this.options.lang
      if (newChat) {
        this.chatStored = { chatId: this.options.idInit, messages: [], members: [] }
        this.saveChat()
        this.clear()
      }

      this.fromnUri = username + '@' + this.options.registrar

      if (!this.sipUser) {
        const transportOptions = {
          server: this.options.wsServer,
        }
        const uri = SIP.UserAgent.makeURI('sip:' + this.fromnUri)
        const userAgentOptions = {
          authorizationPassword: 'anon',
          authorizationUsername: username,
          displayName: 'webChatUser',
          userAgentString: 'SIP.js-0.21.2 Nexios',
          sessionDescriptionHandlerFactoryOptions: {},
          delegate: {
            onConnect: () => {
              
            },
            onDisconnect: (s) => {
              this.stopPing()
            },
            onInvite: async (invitation) => {
              this.initSipSession(invitation)
            },
            onMessage: (message) => {

              message.accept().then(() => {
                this.handleMessage(message.request.body)
              })
            },
            onNotify: (s) => {
            },
          },
          transportOptions,
          uri,
          traceSip: this.options.traceSip || false,
          logLevel: (this.options.traceSip ? 'debug' : 'error'),
          logBuiltinEnabled: false // Todo removve this

        }

        this.sipUser = new SIP.UserAgent(userAgentOptions)
      }

      this.registerer = new SIP.Registerer(this.sipUser)
      this.sipUser.start().then(() => {
        this.registerer.register()
        this.initRegistererListener(newChat)
      })

      if (details.name) this.chatName = details.name
    }
  }

  startPing(){
    this.stopPing()// clear onld interval just in case
    this.__interval = setInterval(()=>{
      console.log('ping')
      this.sendMessage({ from: this.fromnUri, type: 'COMMAND', action: 'ping' })      
    },2000)
  }

  stopPing(){
    clearInterval(this.__interval)
  }

  initRegistererListener (newChat) {
    this.registerer.stateChange.addListener((state) => {
      switch (state) {
        case 'Initial':
          break
        case 'Registered':
          this.sendInit(this.details, newChat)
          break
        case 'Unregistered':
          // SimpleUser calls onUnregistered, but we are not handling it
          break
        case 'Terminated':
          this.registerer = undefined
          break
        default:
          throw new Error('Unknown registerer state.')
      }
    })
  }

  initSipSession (session) {
    this.session = session

    this.session.stateChange.addListener((state) => {
      switch (state) {
        case 'Initial':
          break
        case 'Establishing':
          break
        case 'Established':
          this.setupLocalMedia()
          this.setupRemoteMedia()
          break
        case 'Terminating':
        // fall through
        case 'Terminated':
          this.callFinished(true, false)
          break
        default:
          throw new Error('Unknown session state.')
      }
    })

    this.handleRinging()
  }

  setupLocalMedia () {
    this.cleanupLocalStream()
    this.localStream = trackStream(new MediaStream())

    this.localStream.onaddtrack = () => {
      this.localVideo.load() // Safari hack, as it doesn't work otheriwse
      this.localVideo.play()
    }
    
    this.session?.sessionDescriptionHandler?.peerConnection.getSenders().forEach((sender) => {
      if (sender?.track?.kind === 'video') {
        this.localStream.addTrack(sender.track)
      }
    })

    this.localVideo.srcObject = this.localStream
    this.localVideo.play()
  }

  setupRemoteMedia () {
    this.cleanupRemoteStream()
    this.remoteStream = trackStream(new MediaStream())
    this.remoteStream.onaddtrack = () => {
      this.remoteVideo.load() // Safari hack, as it doesn't work otheriwse
      this.remoteVideo.play().then(()=> {
        this.area2.chatVideoOut.classList.add('animateVideoOut')
        setVisible(this.area2.chatVideoIn, true)
      }).catch((error) => {
        console.error(error)
      })
    }

    this.session?.sessionDescriptionHandler?.peerConnection.getReceivers().forEach((receiver) => {
      if (receiver.track) {
        this.remoteStream.addTrack(receiver.track)
      }
    })

    this.remoteVideo.autoplay = true // Safari hack, because you cannot call .play() from a non user action
    this.remoteVideo.srcObject = this.remoteStream
    this.remoteVideo.play().then(()=> {
      this.area2.chatVideoOut.classList.add('animateVideoOut')
      setVisible(this.area2.chatVideoIn, true)
    })
    attachSinkId(this.remoteVideo, this.settings.audioOut.value)
  }

  cleanupLocalTracks () {
    let tracks = this.localStream?.getTracks()
    tracks?.forEach(track => {
      track.stop()
      track.enabled = false
      this.localStream.removeTrack(track)
    })
  }

  cleanupLocalStream () {
    this.cleanupLocalTracks()
    this.localVideo.pause()
    this.localVideo.srcObject = null
  }

  cleanupRemoteStream () {
    let tracks = this.remoteStream?.getTracks()
    tracks?.forEach(track => {
      track.stop()
      track.enabled = false
      this.remoteStream.removeTrack(track)
    })

    this.remoteVideo.pause()
    this.remoteVideo.srcObject = null
  }

  cleanupMedia () {
    this.cleanupLocalStream()
    this.cleanupRemoteStream()
    this.__audio?.pause()
    if (this.session) {
      this.session.sessionDescriptionHandler?.peerConnection.getSenders().forEach((sender) => {
        if (sender.track) {
          sender.track.stop()
        }
      })

      this.session.sessionDescriptionHandler?.peerConnection.getReceivers().forEach((receiver) => {
        if (receiver.track) {
          receiver.track.stop()
        }
      })

      this.session.sessionDescriptionHandler?.peerConnection.close()
    }
  }


  showSurveyButton() {
    if(!this.isChatbotSurvey) {
      setVisible(this.chatEnd, false)
      setVisible(this.sendboxWrapper, false)
      setVisible(this.surveyButtonWrapper, true)
      setVisible(this.sendBox, true)
    }
    // this.visibleIs('question')
  }

  hideSurvey() {
    if(!this.options.isPreview){
      this.visibleIs('chat')
    }
  }

  surveyFinished() {
    // this.surveyThankYou = this.getTranslated(this.survey, 'thankYouText')
    this.surveyThankYou = ''
    const thankYouMessage = this.getTranslated(this.survey, 'thankYouText')
    this.surveyThankYouMessage.innerHTML = `<span>${nl2br(thankYouMessage)}</span>`
    this.surveySent = true
    
    //this.leave(false)
    setVisible(this.sendBox, true)
    setVisible(this.sendboxWrapper, false)
    setVisible(this.surveyButtonWrapper, false)
    setVisible(this.closeButtonWrapper, true)
    this.visibleIs('chat')
  }

  end () {
    // TODO Davor - ova linija ispod je bila below "this.videoAutoAnswer = false" - ima više smisla da je na početku func - a moguce da i ne treba uopce
    // var leave = { from: this.fromnUri, time: Date.now(), type: 'LEAVE' }
    // if (this.started) this.sendMessage(leave, false)
    if(!this.options.isPreview){
      this.__audio?.pause()
      this.started = false
      this.userFailedFormValidation = false
      this.videoAutoAnswer = false
      this.cleanupMedia()
      if (!this.agentEneteredChat) {
        this.leave()

        return
      }

      if (localStorage.getItem(SURVEY_KEY) && !this.options.disableSurveyOnFinish) {
        this.showSurveyButton()

        return
      }

      var result = { user: false, surveyConfigured: false }
      this.sendSurveyMsg(result)
      this.leave()
      this.chatEnded()
      this.afterClose()
    }
  }

  leave (clearChat = true) {
    var leave = { from: this.fromnUri, time: Date.now(), type: 'LEAVE' }
    this.sendMessage(leave, false)
    this.started = false
    this.agentEneteredChat = false

    if (clearChat) {
      this.clear()
    }
    this.chatStored = {}
    this.saveChat()

    this.chatEnded()
    this.sipUser?.stop()
    this.__audio?.pause()
    // if chat is cleared set chatFinished to false to be able to start new chat
    if(clearChat) this.chatFinished = false
  }

  closeChat() {
    this.surveySent = false
    this.setAgentNickname('')
    this.clear()
    this.visibleIs('button')
    this.chatFinished = false
  }

  chatEnded () {
    this.stopPing()
    this.__audio?.pause()
    if (INVITE.invite) {
      this.visibleIs('endInvite')
    } else if (this.surveyThankYou) {
      this.setThankYouMsg()
      this.visibleIs('thankYou')
      this.surveyThankYou = ''
      // if(this.options.contactDataForm) this.area.thankYou.querySelector('button[p="bt.minimize"]').removeAttribute('hidden')
      // else this.area.thankYou.querySelector('span[p="bt.minimize"]').setAttribute('hidden', true)
    
    } else if (!this.surveySent) {
      this.visibleIs('button')
    }

    localStorage.removeItem(SURVEY_KEY)
    /** turnOffLocalStorage
    localStorage.removeItem(USERNAME_KEY)
    localStorage.removeItem(FORM_DATA_KEY)
    localStorage.removeItem(SURVEY_STARTED_KEY)
    localStorage.removeItem(USER_MODE_STARTED_KEY)
    localStorage.removeItem(CALL_RECEIVED_KEY)
    localStorage.removeItem(DEVICE_SETTINGS_KEY)
    localStorage.removeItem(this.chatStoreKey)
    */
    this.sipUser = null
    if (!this.surveySent) {
      this.setAgentNickname('')
    }
    this.setFormInitialData()
  }

  cleanSurvey () {
    
//    for (var i = 1; i <= 5; i++) this[ `stars-${i}` ].checked = false
   // for (var i = 0; i <= 2; i++) this[ `an-${i}` ].checked = false
//for (var i = 1; i <= 10; i++) this[ `suggestion-${i}` ].checked = false
  }

  showSurvey (show) {
    if(!this.options.isPreview){
      if (show) {
        // localStorage.setItem(SURVEY_STARTED_KEY, 'yes')
        this.visibleIs('survey')
        this.cleanSurvey()
      } else {
        var result = { surveyId: this.survey?.id, accepted: false, user: false, surveyConfigured: true }
        this.sendSurveyMsg(result)
        this.leave()
        this.chatEnded()
        this.afterClose()
      }
    }
  }

  sendSurveyMsg (surveyMsg) {
    let message = { from: this.fromnUri, survey: surveyMsg, time: Date.now(), type: 'COMMAND' }
    this.sendMessage(message)
  }

  sendSurvey (isChatbotSurvey, responses) {
    if(this.options.isPreview){
      return 
    }

    let items = this.survey.items
    let result = { surveyId: this.survey.id, accepted: true, user: true, surveyConfigured: true }
    let lang = this.options.lang

    if(isChatbotSurvey){
      responses.map((item, i)=>{
        result["int_" + (i+1)] = parseInt(responses[i].inputs[0].value)
        result[ 'field_' + responses[i].id ] = responses[i].inputs[0].value
      })
    } else {
      for(var i = 0; i < this.surveyQuestions.children.length; i++){
        let questionEl = this.surveyQuestions.children[i]
        let questionSurvey = items[i]
        let intI = i+1

        if(questionSurvey.type == 'RATE' || questionSurvey.type == 'NUMERIC') {
          const inputs = questionEl.querySelectorAll('input')
          inputs.forEach(input => {
            if(input.checked) {
              result["int_" + intI] = parseInt(input.value)
              result["field_" + intI] = input.value
            }
          })

        } else if(questionSurvey.type == 'OPTIONS') {
          let qOptions = questionSurvey.optionsTrans && questionSurvey.optionsTrans.length ? questionSurvey.optionsTrans[lang] : questionSurvey.options
          const inputs = questionEl.querySelectorAll('input')
          inputs.forEach(input => {
            if(input.checked) {
              let val = qOptions[input.value]
              result["int_" + intI] = parseInt(input.value)
              result["field_" + intI] = val
            }
          })

        } else {
          const txtArea = questionEl.querySelector('textarea')
          result["int_" + intI] = 0
          result["field_" + intI] = txtArea.value || null
        }
      }
    }
    
    this.sendSurveyMsg(result)
    this.surveyFinished()
  }

  getTranslated(src, code){
    if(!src) return ''
    let trans = src[code+'Trans']?.[this.options.lang]
    return trans ? trans : src[code]
  }

  enableSubmitSurvey () {
    if (this.answersInSurvey.length == this.enableSubmitSurveyBtLen){
      this.bt.sendSurvey.removeAttribute('disabled')
    } else {
      this.bt.sendSurvey.setAttribute('disabled', true)
    }
  }

  changeStatus (my, sipStatus) {}

  starTimer () {
    this.stopTimer()
    let counter = 0
    this.timer = setInterval(() => {
      counter++
      this.displaySeconds(counter)
    }, 1000)
  }

  stopTimer () {
    this.displaySeconds(0)
    window.clearInterval(this.timer)
  }

  displaySeconds (secNum) {
    if (!secNum || secNum == 0) {
      this.callCounter.innerHTML = '00:00'

      return
    }

    let hours = Math.floor(secNum / 3600)
    let minutes = Math.floor((secNum - hours * 3600) / 60)
    let seconds = secNum - hours * 3600 - minutes * 60

    if (hours > 0 && hours < 10) {
      hours = '0' + hours
    }
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    if (seconds < 10) {
      seconds = '0' + seconds
    }

    this.callCounter.innerHTML = (hours ? hours + ':' : '') + minutes + ':' + seconds
  }

  getCallType () {
    return this.callType || 'chat_video'
  }

  isVideoCall () {
    return this.getCallType() === 'chat_video'
  }

  isAudioCall () {
    console.log("IS AUDIO CALLLL")
    return this.getCallType() === 'audio'
  }

  checkVideoVisible () {
    const isVideoCall = this.isVideoCall()
    setVisible(this.areaVideo, isVideoCall)
    setVisible(this.bt.videoEnabled, isVideoCall)
    setVisible(this.bt.videoDisabled, false)
    setVisible(this.bt.audioEnabled, true)
    setVisible(this.bt.audioDisabled, false)
  }

  acceptCall () {
    this.cleanupLocalTracks()
    this.__audio?.pause()

    try {
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: this.isVideoCall() })
        .then(stream => {
          // TODO - those two lines below must stay in this order, or video device change will break down
          this.localStream = trackStream(stream)
          this.cleanupLocalStream()
          const isVideoCall = this.isVideoCall()
          this.videoStreamingActive = isVideoCall
          setVisible(this.modal, 0)
          setVisible(this.callActions, 1)
          setVisible(this.settingsButton, 1)
          setVisible(this.chatEnd, 1)
          this.resizeForVideo(false)

          const micId = this.settings.audioIn.value
          const camId = isVideoCall ? this.settings.videoIn.value : false
          const audio = micId ? { deviceId: { exact: micId } } : true
          const video = camId ? { deviceId: { exact: camId } } : isVideoCall

          const acceptOptions = {
            sessionDescriptionHandlerOptions: {
              constraints: {
                audio,
                video,
              },
            },
          }

          this.session.accept(acceptOptions)
          this.starTimer()
          this.checkVideoVisible()

          if (this.isVideoCall()) {
            this.callDialog.classList.add('video');
          } else {
            this.callDialog.classList.remove('video');
          }
          
          setVisible(this.callDialog, true)
          
          setVisible(this.bt.videoDisabled, false)
          setVisible(this.bt.micDisabled, false)
        })
        .catch(err => {
          this.mediaDevicesError(this.isVideoCall())
        })
    } catch (e) {
      this.mediaDevicesError(this.isVideoCall())
    }
  }

  mediaVideo (enable, sendMediaMessage = true) {
    this.videoStreamingActive = enable
    setVisible(this.bt.videoDisabled, !enable)
    setVisible(this.bt.videoEnabled, enable)

    this.session?.sessionDescriptionHandler?.peerConnection.getSenders().forEach((sender) => {
      if (sender?.track?.kind === 'video') {
        sender.track.enabled = enable
      }
    })

    if (sendMediaMessage) {
      this.sendMediaMsg((enable ? 'startVideo' : 'stopVideo'))
    }
  }

  mediaSound = function(enable) {
    setVisible(this.bt.audioDisabled, !enable)
    setVisible(this.bt.audioEnabled, enable)

    this.session?.sessionDescriptionHandler?.peerConnection.getSenders().forEach((sender) => {
      if (sender?.track?.kind === 'audio') {
        sender.track.enabled = enable
      }
    })
    this.sendMediaMsg((enable ? 'startAudio' : 'stopAudio'))
  }

  sendMediaMsg (action) {
    var message = { from: this.fromnUri, type: 'COMMAND', action: action }
    this.sendMessage(message)
    this.localDeivceUpdated(action)
  }

  callFinished (hangup, sendMediaMessage = true) {
    setVisible(this.modal, 0)
    setVisible(this.callActions, 0)
    setVisible(this.settingsButton, 0)
    setVisible(this.areaVideo, 0)
    setVisible(this.chatEnd, 1)
    setVisible(this.callDialog, 0)
    this.remoteDeivceUpdated('all-on')
    this.localDeivceUpdated('all-on')
    if (this.isVideoCall()) {
      this.mediaVideo(false, sendMediaMessage)
      if (isVisible(this.deviceSettings)) {
        setVisible(this.deviceSettings, false)
      }
    }

    if (this.callInProgress) {
      var date = new Date()
      const msg = {
        type: 'CALL_END',
        time: date.getTime(),
      }
      this.addChatMessage(msg, true)
    }

    this.callInProgress = false
    if (hangup) {
      this.hangupCall()
    }

    this.resizeForVideo(true)
    this.__audio?.play()
  }

  hangupCall () {
    this.cleanupMedia()
    switch (this.session?.state) {
      case 'Initial':
      case 'Establishing':
        if (this.session instanceof SIP.Inviter) {
          this.session?.cancel()
        } else {
          this.session?.reject()
        }
        break
      case 'Established':
        this.session?.bye()
        break
      case 'Terminating':
      case 'Terminated':
        // Cannot terminate a session that is already terminated
        break
    }

    this.session = undefined
  }

  setAgentNickname (nickName = '') {
    this.agentNickname.innerHTML = !this.hasBot && !nickName ? t('welcome') : nickName ? nickName : this.chatBotName
    this.iconChat.setAttribute('icon', (nickName || !this.hasBot) ? 'agent' : 'bot')
  }

  resizeForVideo (hangup) {
    if (this.isVideoCall() || this.baseHeight == '100%') {
      return
    }

    const baseHeight = typeof this.baseHeight == 'number' ? this.baseHeight : parseInt(this.baseHeight)
    this.parentFrame.height = hangup ? baseHeight : baseHeight + 285
  }

  handleRinging (sipSession) {
    //turnOffLocalStorage localStorage.setItem(CALL_RECEIVED_KEY, 'yes')
    if (this.videoAutoAnswer) {
      this.acceptCall()
      this.videoAutoAnswer = false
      return
    }

    var text = t('is_calling_accept') + '?'
    this.showModal(text)
  }

  /**
   * Reset all options that "expired" message could have changed
   */
  handleChatStarted (code) {
    this.chatExpired = !code
    this.setVisibleSendbox(code)
  }

  setVisibleSendbox(code){
    code = !this.options.chatDialog || this.chatbotKnowledge || this.transferedToAgent ? true : code

    setVisible(this.sendBox, code)
    if(code) {
      this.area.chat.style = `padding: ${this.screenType.Mobile ? '73px': '24px'} 20px 105px;`
    } else {
      this.area.chat.style = `padding: ${this.screenType.Mobile ? '73px': '24px'}  20px 20px;`
    }

    this.setMessageInputAsReadonly(!code)
  }

  handleChatExipred () {
    this.cleanupMedia()
    if (this.visibleGroup == 'settings') {
      //TODO Tomo - ovo se desi kad se expired desi dok otvaraš chat (npr stari link)
      // startButton (začni klepet) će nestati, ali tu možeš dodati možda neku poruku ili sl.
      this.visibleIs('expiredChat')
      setVisible(this.bt.start, false)
    } else {
      //TODO Tomo - ovo se desi kad se expired desi dok je client u chatu
      // p="chatMessageInput" će dobiti readonly="true" pa cssom možeš možda zasiviti polje ili sl.
      this.visibleIs('expiredChat')
      this.chatMessageInput.setAttribute('readonly', true)
      this.chatExpired = true
      this.chatMessageInput.value = ''
      setVisible(this.sendButton, false)
    }
  }

  handleUnavailableChat () {
    this.visibleIs('unavailableChat')
    this.cleanupMedia()
    this.stopPing()
    var leave = { from: this.fromnUri, time: Date.now(), type: 'LEAVE' }
    this.sendMessage(leave, false)
    this.started = false
    this.agentEneteredChat = false
    this.clear()
    this.chatStored = {}
    this.sipUser?.stop()
    this.__audio?.pause()
  }
  
  setMessageInputAsReadonly(isReadonly) {
    if(!isReadonly) this.chatMessageInput.removeAttribute('readonly')
    else this.chatMessageInput.setAttribute('readonly', true)
    
    setVisible(this.sendButton, !isReadonly) 
  }

  setSurvey () {    
    let defLang = this.options.lang
    var questions = ''
    this.optAnswers = []
		let emojiIcons = ['emoji-sad', 'emoji-desatisfied', 'neutral', 'emoji-satisfied', 'emoji-happy']
    let questionsWoFreeText = this.survey.items.filter(item => item.type != 'FREE_TEXT')
    this.enableSubmitSurveyBtLen = questionsWoFreeText.length

    for(var i=0;i<this.survey.items.length;i++){
      let item = this.survey.items[i]
      let lbl = item?.labelTrans &&  item?.labelTrans[defLang] ? item.labelTrans[defLang] : item.label
      
      if(item.type == 'RATE') {
        let className = item.style && item.style == 'EMOJIS' ? 'emoticons-score' : 'star-rating'

        let question = '<div class="form-line">'
        question += '<label id="survey.items' + i + '">' + lbl + '</label>'
        question += '<div class="'+className+'">'
        
        if(item.style && item.style == 'EMOJIS') {
          for(var j=0; j<item.answers.length; j++){
            let a = item.answers[j]
            question += '<label class="checkcontainer" id="items_'+ i +'_sp_answers_">'
            question += '<input type="radio" id="item_' + i + '_' + a.answer  + '" name="rate_' + i + '" value="' + a.answer + '" onclick="surveyAnswerClick('+item.id+')" />'
            question += '<span class="emoji-checkmark" icon="' + emojiIcons[j] + '"></span>'
            question += '</label>'             
          }
        } else {
          for(var j=item.answers.length - 1; j>=0; j--){
            let a = item.answers[j]
            question += '<input type="radio" id="item_' + i + '_' + a.answer  + '-stars" name="rate_' + i + '" value="' + a.answer + '" onclick="surveyAnswerClick('+item.id+')" />'
            question += '<label for="item_' + i + '_' + a.answer + '-stars" class="star">&#9734;</label>'         
          } 
        }
        question += '</div>'
        question += '</div>'
        questions += question
      }else if(item.type == 'OPTIONS') {
        let answ = item.answers
        if(item.optionsTrans && item.optionsTrans[defLang]){
          answ = item.optionsTrans[defLang].map(item => { return {answer: item}})
        }

        let question = '<div class="form-line">'
        question += '<label id="survey.items' + i + '">' + lbl + '</label>'
        for(var k=0;k<answ.length;k++){
          let ans = answ[k]
          this.optAnswers.push(ans.answer)
          
          question += '<div class="form-inline form-radio-classic">'
          let idx = k
          question += '<label class="checkcontainer" id="items_'+ i +'_sp_answers_' + idx  + '">'
          question += '<input type="radio" id="items_' + i +'_answers_' + idx + '" name="items_' + i + '_answers" value="' + idx + '" onclick="surveyAnswerClick('+item.id+')" /><span class="checkmark" id="items_'+i+'_sp_answers_' + idx + '"></span>'
          question += '<span>' + ans.answer + '</span>'  
          question += '</label>'  
          question += '</div>' 
        }
        
        question += '</div>'
        questions += question

      }else if(item.type == 'NUMERIC') {
        let question = '<div class="form-line">'
        question += '<label id="survey.items' + i + '">' + lbl + '</label>'
        question += '<div class="form-inline form-radio num-rating">'
        
        for(var k=0;k<item.answers.length;k++){
          let ans = item.answers[k]
          question += '<label class="checkcontainer">'
          question += '<input id="item_' + i +'_suggestion' + ans.answer +'" type="radio" name="item_' + i +'_suggestion" value="' + ans.answer + '" selector="--checkbox-bg,--checkbox-fg" onclick="surveyAnswerClick('+item.id+')" />'
          question += '<span class="checkmark">' + ans.answer + '</span>'
          question += '</label>'   
        }
        
        question += '</div>' 
        question += '</div>'
        questions += question
        
      } else if(item.type == 'FREE_TEXT') {
        let question = '<div class="form-line">'
        question += '<label id="survey.items' + i + '" class="survey-label">' + lbl + '</label>'
        question += '<textarea id="survey.items' + i + 'value" class="textarea-form-control" maxlength="500" required></textarea>'
        question += '</div>' 
        questions += question
      }
    }

    this.surveyQuestions.innerHTML = questions
  
    window.surveyAnswerClick = (id) => {
      if(this.answersInSurvey.includes(id)) {
        return
      }

      this.answersInSurvey.push(id)
      this.enableSubmitSurvey()
    }
   
  }

  
  
  async startVideoScan(message){
    const config = JSON.parse(message.text)
    const authorization = JSON.parse(config.authorizationToken)

    const videoScanOptions = {
      sdkUrl: config.sdkUrl,
      provider: config.serviceProvider,
      service: config.service,
      lang: "en",
      serviceProvider: config.serviceProvider,
      documentTypes: config.documentTypes,
      accessToken: authorization.authorization
    }
    
    await initializeEid(videoScanOptions, this)
  }
  
  
  
  handleMessage (evt) {
    this.surveyBotStored = {}
    //1640 kada se finishira chat od strane clienta, ne prihvacati vise poruke
    if (!this.started) return

    var chatStored = this.chatStored

    var message = b64DecodeUnicode(evt)

    if (message[ 0 ] == '{') {
      message = JSON.parse(message)
    } else {
      message = { text: message }
    }

    message = parseIncomingMessage(message)
    if(message.from === '__chat_bot__') {
      this.receivedMessageFromChatbot = true
    }
    // console.warn('handle message', message)
    if(message.action == 'startChatbotKnowledge') {
      this.chatbotKnowledge = true
      this.sendboxWrapper.classList.remove('no-input')
      setAttribute(this.chatMessageInput, 'disabled', false)
      this.chatMessageInput.focus()
    }

    if(this.options.debug) console.log('type:',message.type,', message:', message )
    if (message.type == 'CALL_START') {
      message.text = t('call_start')
      this.addChatMessage(message, true)
    } else if (message.type == 'CALL_END') {
      message.text = t('call_end')
      this.addChatMessage(message, true)
      this.sipUser.hangup()
      this.__audio?.play()
    } else if (message.type == 'COMMAND') {
  	  let code = message.action == 'startChatbotKnowledge' ? true : false
      this.setVisibleSendbox(code)

      
      if (message.action == 'response') {
        let response = message.data
        let promise = responseMap.get(response.id)
        if(promise){
          promise.resolve(response.resp)
          responseMap.delete(response.id)
        }
      } else if (message.action == 'survey') {
        let loaderMessage = this.el.querySelector('[loading="loading"]')
        if(loaderMessage){
          loaderMessage.remove()
        }
        var surveyItem = this.getSurveyItemFromMessage(message)
        if (surveyItem?.type === 'SURVEY') {
          this.survey = surveyItem
          this.setSurvey()
          if(message.from === '__chat_bot__'){
            this.isChatbotSurvey = true
            this.surveyBotStored = {
              id: surveyItem._id,
              type: surveyItem.type,
            }
            
            let div = chatSurvey(this, surveyItem)
            insert(this.chatMessages, div)

            let msgText = JSON.parse(message.text)
            msgText.items = surveyItem.items
            msgText = JSON.stringify(msgText)
            message.text = msgText
            this.chatStored.messages.push(message)
            this.saveChat()
            this.chatMessages.scrollIntoView({ block: "end" })

            setVisible(this.sendBox, false)
            setVisible(this.sendboxWrapper, false)
          }
        }
        
        if (surveyItem?.type === 'CHAT_DIALOG') {
          this.isChatbotSurvey = false
          this.surveyBotStored = {
            id: surveyItem._id,
            type: surveyItem.type,
          }
          let div = chatSurvey(this, surveyItem)
          insert(this.chatMessages, div)
          // commented out bc you can answer prev survey after, 6232
          // this.checkSurveyInLocalstore()

          let msgText = JSON.parse(message.text)          
          msgText.items = surveyItem.items
          msgText = JSON.stringify(msgText)
          message.text = msgText
          this.chatStored.messages.push(message)
          this.saveChat()
          this.chatMessages.scrollIntoView({ block: "end" })
        }

      } else if (message.action == 'error') {
        //TODO Tomo - ovdje se hendla error message ako dođe sa backenda - s tim da sa time se ništa ne radi osim prikaže u konzoli
        console.log('ERROR MESSAGE', message)
      } else if (message.action == 'mediaChange') {
        this.remoteDeivceUpdated(message.text)
      } else if (message.action == 'expired') {
        this.handleChatExipred()
      } else if (message.action == 'notAllowed') {
        this.handleChatExipred()
      } else if (message.action == 'callType') {
        this.callInProgress = true
        const obj = JSON.parse(message.text)
        this.callType = obj.channel
        const msg = {
          type: 'CALL_START',
          time: message.time,
        }
        this.addChatMessage(msg, true)
      } else if (message.action == 'not_ready' || message.action == 'busy') {
        this.$s.unavailableMsg = message.text
        this.handleUnavailableChat()

      } else if (message.action == 'outsideWorkingHours') {
        let txt = JSON.parse(message.text)
        this.$s.unavailableMsg = txt?.outsideWorkingHours ? txt.outsideWorkingHours : t('outside_working_hours')
        this.handleUnavailableChat()

      } else if(message.action === 'scanId'){
        let config = JSON.parse(message.text)
        this.addChatMessage(message)
      } else if(message.action == 'startChatbotKnowledge') {
        
      }else {
        console.error('wrong message action', message)
      }
    } else if (chatStored.chatId == this.options.idInit && message.chatId) {
      this.clear()
      chatStored.chatId = message.chatId
      this.addChatMember({ name: this.chatName, address: this.fromnUri, startTime: Date.now() })
      this.restore()
    } else {
      if (message.type == 'FINISHED') {
        this.chatFinished = true
        message.text = t(message.text)
        chatStored.state = 'HANDLED'
        if(this.options.finishChatOnCallEnd && (this.isVideoCall() || this.isAudioCall()) ){
          this.cleanupMedia()

          if(!this.options.disableSurveyOnFinish){
            this.showSurveyButton()
          } else {
            this.leave()
            this.setThankYouMsg()
            this.visibleIs('thankYou')
          }

        }

        if (localStorage.getItem(SURVEY_KEY) && this.agentEneteredChat && !this.options.disableSurveyOnFinish) {
          this.showSurveyButton()
        }

        if(this.options.disableSurveyOnFinish) {
          setVisible(this.sendboxWrapper, false)
        }

        this.cleanupMedia()
      }
      if (message.type == 'AGENT') {
        this.transferedToAgent = true
        this.setVisibleSendbox(true)
        this.agentEneteredChat = true
        let agentName = this.options.agentName ? this.options.agentName : message.name
        this.addChatMember({
          address: message.from,
          name: agentName,
          startTime: message.time,
        })

        this.setAgentNickname(agentName)
        this.receivedMessageFromChatbot = false
        let loaderMessage = this.el.querySelector('[loading="loading"]')
        if(loaderMessage){
          loaderMessage.remove()
        }
        this.sendboxWrapper.classList.remove('no-input')
        setAttribute(this.chatMessageInput, 'disabled', false)
        this.chatMessageInput.focus()
      }

      let loaderMessage = this.el.querySelector('[loading="loading"]')
      if (message.from === '__chat_bot__' && loaderMessage && this.receivedMessageFromChatbot) {
          var dt = this.parseTime(message.time)
          var time = dt ? String(dt.getHours()).padStart(2, '0') + ':' + String(dt.getMinutes()).padStart(2, '0') : ''
          loaderMessage.replaceWith(this.createChatMsg(message, 'ChatBot', time, false))
          this.sendboxWrapper.classList.remove('no-input')
          setAttribute(this.chatMessageInput, 'disabled', false)
          this.chatMessageInput.focus()
          this.chatMessages.scrollIntoView({ block: "end" })
      } else {
        this.addChatMessage(message, true)
      }
    }
  }

  // toggleSurveyChat(surveyVisible) {
  //   for (let field of this.surveySections) {
  //     console.warn('field', field)
  //     setVisible(this[field], surveyVisible ? 1 : 0)
  //   }

  //   setVisible(this.chatSurvey, surveyVisible ? 1 : 0)
  //   // setVisible(this.sendBox, surveyVisible ? 0 : 1)
  //   setVisible(this.chatMessages, surveyVisible ? 0 : 1)

  // }

  /**
   * Updates the CSS classes of the area.chat element, based on the agent action.
   * If the action is 'video-off' or 'video-on', it adds or removes the 'agentVideoOff' class.
   * If the action is 'audio-off' or 'audio-on', it adds or removes the 'agentAudioOff' class.
   *
   * @param action Device action taken by agent (camera or microphone turned on/off).
   */
  remoteDeivceUpdated(action) {
    const el = this.area.chat
    if (action === 'video-off' || action === 'video-on') {
      classIf(el, 'agentVideoOff', action === 'video-off')
      setVisible(this.agentVideoOff, action === 'video-off')
      if(action === 'video-off'){
        this.area2.chatVideoOut.classList.remove('animateVideoOut')
        this.area2.chatVideoOut.classList.add('animateVideoIn')
      } else {
        this.area2.chatVideoOut.classList.add('animateVideoOut')
        this.area2.chatVideoOut.classList.remove('animateVideoIn')
      }
    }
    
    if (action === 'audio-off' || action === 'audio-on') {
      classIf(el, 'agentAudioOff', action === 'audio-off')
      setVisible(this.agentMicOff, action === 'audio-off')
    }

    if (action === 'all-on' || action === 'all-off') {
      classIf(el, 'agentVideoOff', action === 'all-off')
      classIf(el, 'agentAudioOff', action === 'all-off')
      setVisible(this.agentVideoOff, action === 'all-off')
      setVisible(this.agentMicOff, action === 'all-off')
    }
  }

  /**
   * Updates the CSS classes of the area.chat element, based on the client action.
   * If the action is 'stopVideo' or 'startVideo', it adds or removes the 'clientVideoOff' class.
   * If the action is 'stopAudio' or 'startAudio', it adds or removes the 'clientAudioOff' class.
   *
   * @param action Device action taken by client (camera or microphone turned on/off).
   */
  localDeivceUpdated(action) {
    const el = this.area.chat
    if (action === 'stopVideo' || action === 'startVideo') {
      classIf(el, 'clientVideoOff', action === 'stopVideo')
    }

    if (action === 'stopAudio' || action === 'startAudio') {
      classIf(el, 'clientAudioOff', action === 'stopAudio')
    }

    if (action === 'all-on' || action === 'all-off') {
      classIf(el, 'clientVideoOff', action === 'all-off')
      classIf(el, 'clientAudioOff', action === 'all-off')
    }
  }

  getSurveyItemFromMessage (message) {
    const parsedText = JSON.parse(message.text)
    let surveyType = parsedText?.type
    parsedText.originalSurveyType = surveyType
    if(surveyType === 'Menu') {
      surveyType = parsedText.type = 'CHAT_DIALOG'
      parsedText.items = [{
        label: parsedText.promptText,
        type: 'single',
        options: parsedText.menu.map(m=>m.label)
      }]
    }
    if(surveyType === 'Collect') {
      surveyType = parsedText.type = 'CHAT_DIALOG'
      parsedText.items = parsedText.collectFields 
    }
    
    if (surveyType === 'SURVEY' && localStorage.getItem(SURVEY_KEY) && message.name) {
      return JSON.parse(localStorage.getItem(SURVEY_KEY))
    }

    if (surveyType === 'SURVEY') {
      localStorage.setItem(SURVEY_KEY, message.text)
    }

    return parsedText
  }

  minimize (minimizedFrom = '') {
    if(!this.options.isPreview){
      this.cleanupMedia()
      if (minimizedFrom === 'areaForm') {
        this.setFormInitialData()
        this.hideFormValidationMessages()
        this.userFailedFormValidation = false
      } else {
        setVisible(this.area[minimizedFrom], false)
        if(minimizedFrom == 'survey') this.options.contactDataForm = false
      }
      this.afterClose()
      this.visibleIs('button')
    }
  }

  afterClose(){
    if(this.options.contactDataForm) setVisible(this.area.form, true)
    else {
      setVisible(this.area.expiredChat, true)
      let expiredChat = this.area.expiredChat
      expiredChat.querySelector('span[p="endMsg"]').innerText = t('HANDLED')
    }
  }

  resize (width, height) {
    // if (!INVITE.invite) {
    //   if (this.screenType.Mobile && this.visibleGroup != 'button') {
    //     this.parentFrame.width = '100%'
    //     this.parentFrame.height = '100%'
    //     this.parentFrame.style.cssText = `
    // 		position: fixed;
    // 		bottom: 0;
    // 		right: 0;
    // 		border: 0;
    // 		z-index: 999999;
    // 	`
    //   } else if (this.screenType.Mobile && this.visibleGroup != 'DevicesError') {
    //     this.parentFrame.width = width + 20
    //     this.parentFrame.height = height + 20
    //     this.parentFrame.style.cssText = `
    // 		position: fixed;
    // 		bottom: 0;
    // 		right: -20px;
    // 		border: 0;
    // 		z-index: 999999;
    // 	`
    //   } else if (!this.screenType.Mobile && this.visibleGroup == 'question') {
    //     this.parentFrame.width = width + 20
    //     this.parentFrame.height = height + 20
    //     this.parentFrame.style.cssText = `
    // 		position: fixed;
    // 		bottom: 0;
    // 		right: 10px;
    // 		border: 0;
    // 		z-index: 999999;
    // 	`
    //   } else if (this.visibleGroup == 'DevicesError') {
    //     console.warn(this.visibleGroup)
    //     this.parentFrame.width = '100%'
    //     this.parentFrame.height = '100%'
    //     this.parentFrame.style.cssText = `
    // 		position: fixed;
    // 		bottom: 0;
    // 		right: 0;
    // 		border: 0;
    // 		z-index: 999999;
    // 	`
    //   } else {
    //     this.parentFrame.width = width + 20
    //     this.parentFrame.height = height + 20
    //     this.parentFrame.style.cssText = `
    // 		position: fixed;
    // 		bottom: 0;
    // 		right: -10px;
    // 		border: 0;
    // 		z-index: 999999;
    // 	`
    //   }
    // }
    //
    // this.baseHeight = this.parentFrame.height
  }

  addChatMember (member) {
    var chatStored = this.chatStored

    var found
    for (var i = 0; i < chatStored.members.length; i++) {
      let tmp = chatStored.members[ i ]
      if (tmp.address == member.address) {
        found = chatStored.members[ i ] = member
      }
    }

    if (!found) chatStored.members.push(member)
    this.saveChat()
  }

  getChatMemberName (address) {
    var chatStored = this.chatStored
    for (var i = 0; i < chatStored.members.length; i++) {
      let tmp = chatStored.members[ i ]
      if (tmp.address == address) return tmp.name || '-'
    }
    return '-'
  }

  saveChat (newValue) {
    /** turnOffLocalStorage
    var str = JSON.stringify(newValue || this.chatStored)
    localStorage.setItem(this.chatStoreKey, str)
    */
  }

  clear (message, store) {
    this.chatMessages.innerHTML = ''
    this.chatMessageInput.value = ''
    this.userMode = null
    this.agentEneteredChat = false
  }

  parseTime (t) {
    if (!t) return t
    if (t.millis) return new Date(t.millis)
    return new Date(t)
  }

  URLFromString(text) {
    if (!text || (!text.includes('http') && !text.includes('www'))) return text;
    if (!this.options.transformLinks) return text;

    const markdownRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+|www\.[^\s)]+)\)/g;
    const rawUrlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

    let markdownMatches = [];
    text = text.replace(markdownRegex, (_, label, url) => {
      const placeholder = `___MARKDOWN_LINK_${markdownMatches.length}___`;
      markdownMatches.push({ label, url });
      return placeholder;
    });

    const splitRegex = /(___MARKDOWN_LINK_\d+___|https?:\/\/[^\s]+|www\.[^\s]+)/g;
    const parts = text.split(splitRegex);

    return parts.map((part, index) => {
      const markdownMatch = part.match(/^___MARKDOWN_LINK_(\d+)___$/);
      if (markdownMatch) {
        const { label, url } = markdownMatches[parseInt(markdownMatch[1])];
        const href = url.startsWith('http') ? url : 'https://' + url;
        return (
          <>
            <a href={href} target="_blank" rel="noopener noreferrer" title={href} >
              {label}
            </a>
          </>
        );
      }

      if (rawUrlRegex.test(part)) {
        let trailing = '';
        if (/[.,]$/.test(part)) {
          trailing = part.slice(-1);
          part = part.slice(0, -1);
        }

        let href = part.startsWith('http') ? part : 'https://' + part;

        return (
          <>
            <a href={href} target="_blank" rel="noopener noreferrer" title={href}>
              Link
            </a>
            {trailing}
          </>
        );
      }

      return part;
    });
  }

  addChatMessage (message, store, isDialog, isLoader) {
    if (!this.started) return

    if (store) {
      this.chatStored.messages.push(message)
      this.saveChat()
    }

    const isPreview = this.options.isPreview
    if(isPreview){
      if(isDialog) {
        // Todo konstante
        let div = chatSurvey(this, {
          "type": "CHAT_DIALOG",
          "retry": "3",
          "timeout": "3",
          "promptText": "Who would you like to talk to?",
          "name": "Menu",
          "onTimeout": 6,
          "finalError": 5,
          "menu": [
            {
              "label": "Sales",
              "blockId": "4"
            },
            {
              "label": "Support",
              "blockId": "18"
            }
          ],
          "id": 2,
          "originalSurveyType": "Menu",
          "items": [
            {
              "label": "Who would you like to talk to??",
              "type": "single",
              "options": [
                "Sales",
                "Support"
              ]
            }
          ]
        }, isPreview)
        insert(this.chatMessages, div)
      } else {
        var div3 = this.createChatMsg({
          "from": "8-x0.24125134549818616xNEX@localhost",
          "text": "Welcome! How can I assist you today?",
          "time": 1716982004485,
          "type": "CHATBOT",
          "incomming": true,
          "isChatbotMsg": true
        }, '', '15:13')
        insert(this.chatMessages, div3)
        
        var div = this.createChatMsg({
          "from": "8-x0.24125134549818616xNEX@localhost",
          "text": "Hello can I speak to the agent please?",
          "time": 1716982004485,
          "type": "MESSAGE",
          "incomming": false
        }, 'Customer', '15:14')
        insert(this.chatMessages, div)

        var div2 = this.createChatMsg({
          "type": "MESSAGE",
          "action": "message",
          "time": 1716982142288,
          "from": "2565",
          "text": "I'm here to help with any questions or tasks you have. How can I assist you?",
          "chatId": "665711782afd2e4958889059",
          "name": null,
          "data": null,
          "incomming": true
        }, 'Agent', '15:15')
        insert(this.chatMessages, div2)

        var div = this.createChatMsg({
          "from": "8-x0.24125134549818616xNEX@localhost",
          "text": "Can you help me with google pay settings?",
          "time": 1716982004485,
          "type": "MESSAGE",
          "incomming": false
        }, 'Customer', '15:17')
        insert(this.chatMessages, div)
      }
    } else {
      let name = this.getChatMemberName(message.from)
      if (message.from == '__chat_bot__') name = 'ChatBot'
      var dt = this.parseTime(message.time)
      var time = dt ? String(dt.getHours()).padStart(2, '0') + ':' + String(dt.getMinutes()).padStart(2, '0') : ''

      if (message.type == 'AGENT') time = t('entered_chat') + ' ' + time
      if (message.type == 'LEAVE') time = t('left_chat') + ' ' + time
      if (message.type == 'CALL_START') time = t('call_start') + ' ' + time
      if (message.type == 'CALL_END') time = t('call_end') + ' ' + time
      if (message.type == 'FINISHED') time = time

      if(message.type == 'COMMAND'){
        if(message.action === 'scanId'){
          var div = this.createScanIdMsg(message, name, time)
          insert(this.chatMessages, div)
        } else {
          let answer = message.answer
          message = JSON.parse(message.text)
          if(message.collectFields) message.items = message.collectFields
          if(answer) message.answer = answer

          let div = chatSurvey(this, message)
          insert(this.chatMessages, div)
        }
      } else {

        var div = this.createChatMsg(message, name, time, isLoader)

        insert(this.chatMessages, div)
      }
    }

    this.chatMessages.scrollIntoView({ block: "end" })
  }

createScanIdMsg(message, name, time){
    return <div class="chatbot-form">
            <div class="menu-title">{t('scan_document')}</div>
            <div class="chatbot-select">
              <button class="chatbot-option" onclick={()=>this.startVideoScan(message)}>{t('start')}</button>
            </div>
         </div>
}
  rateDialogMessage(messageId, rating) {
    try {
      const rootDiv = document.querySelector('#NexiosChat');
      if (!rootDiv || !rootDiv.shadowRoot) throw new Error('Shadow root not found.');

      const messageDiv = rootDiv.shadowRoot.getElementById(messageId);
      if (!messageDiv) throw new Error(`Message div with ID ${messageId} not found.`);

      const emojiWrapper = messageDiv.querySelector('.emoji-wrapper');
      if (!emojiWrapper) throw new Error('Emoji wrapper not found.');

      const selectedEmoji = emojiWrapper.querySelector(`[icon=${rating === 'thumbsUp' ? 'thumb-up' : 'thumb-down'}]`);
      const unselectedEmoji = emojiWrapper.querySelector(`[icon=${rating === 'thumbsUp' ? 'thumb-down' : 'thumb-up'}]`);
      if (!selectedEmoji || !unselectedEmoji) throw new Error('Emoji elements not found.');

      const ratingHolder = messageDiv.querySelector('.rating-holder');

      if (selectedEmoji.classList.contains('selected')) {
        console.log('Rating is already set to this value.');
        selectedEmoji.classList.remove('selected');
        //setVisible(ratingHolder, false);
        return;
      }

      setVisible(ratingHolder, true);

      const thumbUpIcon = ratingHolder.querySelector('[icon="thumb-up"]');
      const thumbDownIcon = ratingHolder.querySelector('[icon="thumb-down"]');

      setVisible(thumbUpIcon, rating === 'thumbsUp');
      setVisible(thumbDownIcon, rating !== 'thumbsUp');

      selectedEmoji.classList.add('selected');
      unselectedEmoji.classList.remove('selected');


      const message = {
        from: this.fromUri,
        id: messageId,
        rating: rating,
        time: Date.now(),
        type: 'COMMAND',
        action: 'rating'
      };

      this.sendMessage(message);
    } catch (error) {
      console.error(error.message);
    }
  }

createChatMsg (message, name, time, isLoader) {
  function downloadAttachment(url, fileName) {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.name = 'iframe_download';
    iframe.id = 'iframe_download';

    document.body.appendChild(iframe);

    const form = document.createElement('form');
    form.method = 'GET';
    form.action = url;
    form.target = 'iframe_download';
    form.style.display = 'none';

    document.body.appendChild(form);
    form.submit();

    setTimeout(() => {
      document.body.removeChild(iframe);
      document.body.removeChild(form);
    }, 2000);
  }

  // console.warn(message, name, time, this.fromnUri)
    let text = message.type == 'ATTACH' ? message?.data?.fileName : message.text
    let url = message?.data?.url || ''

    let isAttachment = message.type == 'ATTACH'
    text = this.setOptionsInMsgText(text, isAttachment)

    let messageText = isAttachment ? 
      (<p class="chat-inner-text" onclick={()=> downloadAttachment(url, text)}>{this.URLFromString(text)}</p>) :
      (<p class="chat-inner-text">{this.URLFromString(text)}</p>)
      messageText = isLoader ? <div class="loader"><span></span><span></span><span></span></div> : messageText
    if(!this.hasBot && message.from == '__chat_bot__'){
      this.hasBot = true
      this.setAgentNickname()
    }
    let msgType = message.from == '__chat_bot__' ? 'CHATBOT' : message.type
    let attachClass = isAttachment ? ' chat-attachment' : ''
    let extension = isAttachment ? message?.data?.extension : ''

    let direction = 'OUT'
    if(isAttachment){
      direction = message.from.includes("@") ? 'OUT' : 'IN'
    }else{
      if(this.options.isPreview){
        direction = message.incomming ? 'IN' : 'OUT'
      } else {
        direction = message.from == this.fromnUri ? 'OUT' : 'IN'
      }
    }
    let selector = ''
    if(this.options.isPreview){
      if(message.isChatbotMsg){
        selector = '--msg-bubble-chatbot-bg,--msg-bubble-chatbot-txt,--msg-bubble-chatbot-time'
      } else {
        if (direction === 'IN') {
          selector = '--msg-bubble-in-bg,--msg-bubble-in-txt,--msg-bubble-in-time'
        } else {
          selector = '--msg-bubble-out-bg,--msg-bubble-out-txt,--msg-bubble-out-time'
        }
      }
    }
    
      let messageId = message.id
    const messageRating = msgType === 'CHATBOT' ? (
      <div class="emoji-wrapper">
        <span class="emoji" title="Thumbs up" onclick={()=>this.rateDialogMessage(messageId, "thumbsUp")} icon="thumb-up"></span>
        <span class="emoji" title="Thumbs down" onclick={()=>this.rateDialogMessage(messageId, "thumbsDown")} icon="thumb-down"></span>
      </div>
    ) : ''
    
    const rating = <div class="rating-holder" hidden>
      <span class="emoji" title="Thumbs up" icon="thumb-up" hidden></span> 
      <span class="emoji" title="Thumbs down" icon="thumb-down" hidden></span> 
    </div>
  
  return (
      <div class={
        'chat-message type-' + msgType + ' direction-' + direction + attachClass
      }

       id={messageId}
       loading={isLoader}
      >
        {name ? <label>{text}</label> : ''}
        <span icon="bot" selector="--avatar-icon-color"></span>
        <div class="chat-bubble newlines" extension={extension} selector={selector}>
          <span class="bubble-time">{time}</span>
          {messageText}
          {messageRating}
          {rating}
        </div>
      </div>
    )
  }

  setOptionsInMsgText (text, isAttachment) {
		if(typeof text != 'string' || isAttachment) return text
		let nums = ['1)','2)','3)','4)','5)','6)','7)','8)','9)']

		nums.forEach(num => {
			if(text.includes(num)) text = text.replace(num, '\n'+num)
		})
		return text
	}

  toggleSettings () {
    const setAsVisible = !isVisible(this.deviceSettings)
    if (setAsVisible && !this.sessionSettings.querySelector('[p="setting.deviceSelection"]')) {
      this.getMediaDevices(() => {
        setValue(this.settings.videoIn, this.getDeviceIdFromLocalStorage('videoIn'))
        setValue(this.settings.audioIn, this.getDeviceIdFromLocalStorage('audioIn'))
        setValue(this.settings.audioOut, this.getDeviceIdFromLocalStorage('audioOut'))
      })
      this.sessionSettings.appendChild(this.setting.deviceSelection)
    }

    this.moveVideo(setAsVisible ? 'settings' : 'chat')
    setVisible(this.callActions, !setAsVisible)
    setVisible(this.deviceSettings, setAsVisible)
    setVisible(this.inviteText, !setAsVisible)
  }

  updateDeviceSettings (type = false) {
    /** turnOffLocalStorage
    localStorage.setItem(DEVICE_SETTINGS_KEY, JSON.stringify({
      audioIn: this.settings.audioIn.value,
      audioOut: this.settings.audioOut.value,
      videoIn: this.settings.videoIn.value,
    }))
    */
    const preChatSettingsVisible = isVisible(this.area.settings)
    const startedChatSettingsVisible = isVisible(this.deviceSettings)

    console.log("UPDATE DEVICE SETTINGS")
    if (type !== 'videoIn' && !startedChatSettingsVisible) {
      return
    }

    if (type === 'videoIn' && preChatSettingsVisible) {
      this.applyVideo()
    }

    if (type === 'videoIn' && startedChatSettingsVisible) {
      videoInDeviceChanged(this)
    }

    if (type === 'audioIn') {
      audioInDeviceChanged(this)
    }

    if (type === 'audioOut') {
      attachSinkId(this.remoteVideo, this.settings.audioOut.value)
    }
  }

  sendChatMessage () {
    if(!this.options.isPreview){
      var chatStored = this.chatStored

      if (chatStored.state == 'HANDLED' || this.chatExpired) return

      var text = this.chatMessageInput.value
      if (text) {
        let message = { from: this.fromnUri, text, time: Date.now(), type: 'MESSAGE' }
        this.addChatMessage(message, true)
        this.sendMessage(text)
        this.chatMessageInput.value = ''

        if (this.receivedMessageFromChatbot) {
          let chatbotMessage = { from: '__chatbot__', text: 'test', time: Date.now(), type: 'CHATBOT' }
          this.addChatMessage(chatbotMessage, true, false, true)
          addClass(this.sendboxWrapper, 'no-input')
          setAttribute(this.chatMessageInput, 'disabled', true)
        }
      } 
    }
  }

  rpc(method, params, timeout= 2000){
    const id = ++rpcSequnece
    let message = { from: this.fromnUri, type: 'COMMAND', action: 'request', data: {method, params, id} }

    const p = new Promise((resolve, reject) => {
      this.sendMessage(message)
      responseMap.set(id, {resolve, reject})
    })

    setTimeout(()=>{
      let promise = responseMap.get(id)
      if(promise){
        promise.reject('timeout')
        responseMap.delete(id)
      }
    }, timeout)
    return p;
  }

  async initFileUpload () {
    this.fileUploadConf = null
    this.fileUploadField.value = ''
    this.fileUploadField.click()

    let response = await this.rpc('getFileUploadUrl', {})
    if (response?.url) {
      this.fileUploadConf = response
    }
  }

  finishUpload (fileName) {
    this.fileUploadField.value = ''
    if (!this.fileUploadConf?.url) {
      this.generalError('')

      return
    }
    
    fetch(this.fileUploadConf.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ action: 'end' }),
    }).then((resp) => {
      if (!resp.ok) {
        this.generalError()

        return
      }

      // const text = fileName
      // let message = { from: this.fromnUri, text, time: Date.now(), type: 'MESSAGE' }
      // this.addChatMessage(message, true)
      // this.sendMessage(text)
    }).catch((err) => {
      console.error(err)
    })
  }

  /**
   *
   * @param {File} file
   */
  uploadFile(file) {
    if (!this.fileUploadConf?.url) {
      this.generalError('')

      return
    }

    if (!file || !this.fileUploadConf) {
      return
    }

    const extension = file.name.split('.').pop()
    if (this.fileUploadConf.extensionsLimit.indexOf(extension) === -1) {
      const message = t('file_extension_not_allowed') + this.fileUploadConf.extensionsLimit.join(', ')
      this.generalError(message)

      return
    }

    if (file.size > this.fileUploadConf.fileLimit) {
      const message = t('file_max_size_exceeded') + (this.fileUploadConf.fileLimit/ (1024 * 1024)).toFixed(2) + ' MB'
      this.generalError(message)

      return
    }

    var size = file.size
    var chunkLimit = 64 * 1024

    var offset = 0
    var blob = file.slice(offset, offset + chunkLimit)
    var reader = new FileReader()

    var id
    var sequence = 0
    reader.addEventListener('load', async (e) => {
      var action = offset ? 'rest' : 'start'
      var content = btoa(e.target.result)
      var name = file.name
      var attach = { id, action, content, name, size, sequence }
      let resp = await fetch(this.fileUploadConf.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(attach),
      })

      if (resp.ok) {
        const parsedResponse = await resp.json()
        id = parsedResponse.id
        sequence = parsedResponse.sequence
        chunkLimit = resp.chunkLimit || chunkLimit
        offset += chunkLimit
        if (offset < size) {
          blob = file.slice(offset, Math.min(offset + chunkLimit, size))
          reader.readAsBinaryString(blob)
        } else {
          this.finishUpload(file.name)
        }
      }
    })

    reader.readAsBinaryString(blob)

  }

  sendMessage (message) {
    let disableSendMsg = ((this.options.isPreview || this.chatFinished) && !message.survey && message.type != 'LEAVE') ? true : false
    if(disableSendMsg) {
      return 
    }

    let jumpToBlock = this.jumpToBlockCheck(message)
    if(jumpToBlock) {
      message.jumpToBlock = true
    }

    // if(message.surveyId) delete message.surveyId
    // if survey is submitted and option finishChatOnCallEnd is true, show ty msg and finish chat 
    let showThankYou = message.survey && this.options.finishChatOnCallEnd ? true : false
    
    if (typeof message != 'string') {
      message = JSON.stringify(message)
    }
    
    const target = SIP.UserAgent.makeURI('sip:' + this.chatStored.chatId + '@nexios')
    new SIP.Messager(this.sipUser, target, message).message()
    this.sentAnyMessage = true
    if(!this.sentHandledCommand && this.receivedMessageFromChatbot && this.sentAnyMessage){
      let handledMessage = JSON.stringify({
        "type" : "COMMAND",
        "action" : "chatbotHandled",
      })

      new SIP.Messager(this.sipUser, target, handledMessage).message()
      this.sentHandledCommand = true
    }
    
    if(showThankYou){
      this.leave()
      this.setThankYouMsg()
      this.visibleIs('thankYou')
    }
  }

  sendInit (details, newChat) {
    if (newChat) {
      this.clear()
    }

    this.sendMessage({ details, text: null, type: '' })
  }

  showModal (title) {
    setTimeout(() => {
      const isVideoCall = this.isVideoCall()
      this.incomingCallIcon.setAttribute('icon', isVideoCall ? 'video-call' : 'agent')
      this.modal_content.innerHTML = isVideoCall ? t('incoming_video_call') : t('incoming_call')
      setVisible(this.modal, 1)
    }, 200)
  }

  checkSurveyInLocalstore () {
    for(let i = this.chatStored.messages.length-1; i>=0; i--){
      if(this.chatStored.messages[i].action && this.chatStored.messages[i].action == 'survey'){
        this.chatStored.messages = this.chatStored.messages.filter(item => item.time != this.chatStored.messages[i].time)
        break
      }
    }
  }

  setAnswerLocalStore (answer) {
    for(let i = this.chatStored.messages.length-1; i>=0; i--){
      if(this.chatStored.messages[i].action && this.chatStored.messages[i].action == 'survey'){
        this.chatStored.messages[i].answer = answer
        this.saveChat()
        break
      }
    }
  }

  // if answer on menu that is already answered, remove all chat msg elements after that survey
  jumpToBlockCheck(msg) {
    let discard = false
    let splitIndex = 0
    for(let i = 0; i < this.chatStored.messages?.length; i++) {
      let chat = this.chatStored.messages[i]

      if(chat.type === 'COMMAND' && chat.text) {
        let menu = JSON.parse(chat.text)
        if(menu.id == msg.surveyId){
          splitIndex = i+1
        } 
      }
    }

    if(splitIndex > 0 && this.chatMessages.children.length > splitIndex) {
      discard = true

      for (let i = this.chatMessages.children.length - 1; i >= splitIndex; i--) {
        this.chatMessages.removeChild(this.chatMessages.children[i]);
      }
      this.chatStored.messages = this.chatStored.messages.slice(0, splitIndex)  
    }

    return discard
  }

  setThankYouMsg () {
    let text = t('survey_heading')
    let lang = this.options.lang

    if(this.survey) {
      text = this.survey?.thankYouTextTrans && this.survey?.thankYouTextTrans[lang] ? this.survey.thankYouTextTrans[lang] : this.survey?.thankYouText ? this.survey.thankYouText : text
    }

    this.thankYouText.innerHTML = `<span>${text}</span>`
  }

  tpl () {
    const closeBubble = () => {
      setVisible(this.startBubble, 0)
      document.cookie = 'chatBubbleHidden=yes; path=/'
    }
    this.el.className = 'mainWindow'
    this.startBubble = (
      <div p='startBubble' class='chat-info-bubble'>
        <span
          p='chatEnd'
          onClick={closeBubble}
          icon='x-mark'
          style='position: absolute; top: 15px; right: 15px; cursor: pointer;'
        />
        {T`bubble_txt1`} <br />
        {T`bubble_txt2`}
      </div>
    )

    return (
      <>
        {areaButton(this.startBubble, this)}
        {areaSurvey(this)}
        {areaQuestion(this)}
        {areaForm(this)}
        {areaSettings(this)}
        {areaChat(this)}
        {areaError(this)}
        {areaThankYou(this)}
        {areaDevicesError(this)}
        {areaEndInvite(this)}
        {areaGeneralError(this)}
        {expiredChat(this)}
        {incomingCallModal(this)}
        {unavailableChat(this)}
        <div hidden>
          <video p='remoteVideo' playsinline='true' _controls='true' />
          <video p='localVideo' playsinline='true' _controls='true' />
        </div>
        <div id="video">
          
        </div>
      </>
    )
  }
}
